/**
 * get the image url of the coin from
 * https://coinmarketcap.com/rankings/exchanges/
 * or
 * https://www.coingecko.com/en/exchanges <-- this is the one we are using for exchanges
 *
 */
export const coinImageUrls = {
  // NOTE: exchange logo icons
  binance:
    'https://assets.coingecko.com/markets/images/52/standard/binance.jpg?1706864258',
  bybit:
    'https://assets.coingecko.com/markets/images/698/standard/bybit_spot.png?1706864649',
  coinbase:
    'https://assets.coingecko.com/markets/images/23/standard/Coinbase_Coin_Primary.png?1706864258',
  kraken:
    'https://assets.coingecko.com/markets/images/29/standard/kraken.jpg?1706864265',
  okx: 'https://assets.coingecko.com/markets/images/96/standard/WeChat_Image_20220117220452.png?1706864283',
  upbit:
    'https://assets.coingecko.com/markets/images/117/standard/upbit.png?1706864294',
  gateio:
    'https://assets.coingecko.com/markets/images/60/standard/gate_io_logo1.jpg?1706864280',
  htx: 'https://assets.coingecko.com/markets/images/25/standard/logo_V_colour_black.png?1706864260',
  bitfinex:
    'https://assets.coingecko.com/markets/images/4/standard/BItfinex.png?1706864245',
  kucoin:
    'https://assets.coingecko.com/markets/images/61/standard/kucoin.png?1706864282',
  // NOTE: crypto coin icons
  usdc: 'https://assets.coingecko.com/coins/images/6319/standard/usdc.png?1696506694',
  bitcoin:
    'https://assets.coingecko.com/coins/images/1/large/bitcoin.png?1696501400',
  ethereum:
    'https://assets.coingecko.com/coins/images/279/large/ethereum.png?1696501628',
  tether:
    'https://assets.coingecko.com/coins/images/325/large/Tether.png?1696501661',
  binancecoin:
    'https://assets.coingecko.com/coins/images/825/large/bnb-icon2_2x.png?1696501970',
  solana:
    'https://assets.coingecko.com/coins/images/4128/large/solana.png?1696504756',
  'staked-ether':
    'https://assets.coingecko.com/coins/images/13442/large/steth_logo.png?1696513206',
  ripple:
    'https://assets.coingecko.com/coins/images/44/large/xrp-symbol-white-128.png?1696501442',
  'usd-coin':
    'https://assets.coingecko.com/coins/images/6319/large/usdc.png?1696506694',
  cardano:
    'https://assets.coingecko.com/coins/images/975/large/cardano.png?1696502090',
  dogecoin:
    'https://assets.coingecko.com/coins/images/5/large/dogecoin.png?1696501409',
  'shiba-inu':
    'https://assets.coingecko.com/coins/images/11939/large/shiba.png?1696511800',
  'avalanche-2':
    'https://assets.coingecko.com/coins/images/12559/large/Avalanche_Circle_RedWhite_Trans.png?1696512369',
  polkadot:
    'https://assets.coingecko.com/coins/images/12171/large/polkadot.png?1696512008',
  tron: 'https://assets.coingecko.com/coins/images/1094/large/tron-logo.png?1696502193',
  chainlink:
    'https://assets.coingecko.com/coins/images/877/large/chainlink-new-logo.png?1696502009',
  'matic-network':
    'https://assets.coingecko.com/coins/images/4713/large/polygon.png?1698233745',
  uniswap:
    'https://assets.coingecko.com/coins/images/12504/large/uni.jpg?1696512319',
  'wrapped-bitcoin':
    'https://assets.coingecko.com/coins/images/7598/large/wrapped_bitcoin_wbtc.png?1696507857',
  'the-open-network':
    'https://assets.coingecko.com/coins/images/17980/large/ton_symbol.png?1696517498',
  'bitcoin-cash':
    'https://assets.coingecko.com/coins/images/780/large/bitcoin-cash-circle.png?1696501932',
  'internet-computer':
    'https://assets.coingecko.com/coins/images/14495/large/Internet_Computer_logo.png?1696514180',
  litecoin:
    'https://assets.coingecko.com/coins/images/2/large/litecoin.png?1696501400',
  near: 'https://assets.coingecko.com/coins/images/10365/large/near.jpg?1696510367',
  filecoin:
    'https://assets.coingecko.com/coins/images/12817/large/filecoin.png?1696512609',
  'ethereum-classic':
    'https://assets.coingecko.com/coins/images/453/large/ethereum-classic-logo.png?1696501717',
  'leo-token':
    'https://assets.coingecko.com/coins/images/8418/large/leo-token.png?1696508607',
  cosmos:
    'https://assets.coingecko.com/coins/images/1481/large/cosmos_hub.png?1696502525',
  aptos:
    'https://assets.coingecko.com/coins/images/26455/large/aptos_round.png?1696525528',
  'immutable-x':
    'https://assets.coingecko.com/coins/images/17233/large/immutableX-symbol-BLK-RGB.png?1696516787',
  optimism:
    'https://assets.coingecko.com/coins/images/25244/large/Optimism.png?1696524385',
  'render-token':
    'https://assets.coingecko.com/coins/images/11636/large/rndr.png?1696511529',
  bittensor:
    'https://assets.coingecko.com/coins/images/28452/large/ARUsPeNQ_400x400.jpeg?1696527447',
  'crypto-com-chain':
    'https://assets.coingecko.com/coins/images/7310/large/cro_token_logo.png?1696507599',
  dai: 'https://assets.coingecko.com/coins/images/9956/large/Badge_Dai.png?1696509996',
  'hedera-hashgraph':
    'https://assets.coingecko.com/coins/images/3688/large/hbar.png?1696504364',
  'the-graph':
    'https://assets.coingecko.com/coins/images/13397/large/Graph_Token.png?1696513159',
  blockstack:
    'https://assets.coingecko.com/coins/images/2069/large/Stacks_Logo_png.png?1709979332',
  stellar:
    'https://assets.coingecko.com/coins/images/100/large/Stellar_symbol_black_RGB.png?1696501482',
  pepe: 'https://assets.coingecko.com/coins/images/29850/large/pepe-token.jpeg?1696528776',
  okb: 'https://assets.coingecko.com/coins/images/4463/large/WeChat_Image_20220118095654.png?1696505053',
  'injective-protocol':
    'https://assets.coingecko.com/coins/images/12882/large/Secondary_Symbol.png?1696512670',
  vechain:
    'https://assets.coingecko.com/coins/images/1167/large/VET_Token_Icon.png?1710013505',
  kaspa:
    'https://assets.coingecko.com/coins/images/25751/large/kaspa-icon-exchanges.png?1696524837',
  mantle:
    'https://assets.coingecko.com/coins/images/30980/large/token-logo.png?1696529819',
  'first-digital-usd':
    'https://assets.coingecko.com/coins/images/31079/large/firstfigital.jpeg?1696529912',
  'fetch-ai':
    'https://assets.coingecko.com/coins/images/5681/large/Fetch.jpg?1696506140',
  'theta-token':
    'https://assets.coingecko.com/coins/images/2538/large/theta-token-logo.png?1696503349',
  'lido-dao':
    'https://assets.coingecko.com/coins/images/13573/large/Lido_DAO.png?1696513326',
  arbitrum:
    'https://assets.coingecko.com/coins/images/16547/large/photo_2023-03-29_21.47.00.jpeg?1696516109',
  celestia:
    'https://assets.coingecko.com/coins/images/31967/large/tia.jpg?1696530772',
  arweave:
    'https://assets.coingecko.com/coins/images/4343/large/oRt6SiEN_400x400.jpg?1696504946',
  monero:
    'https://assets.coingecko.com/coins/images/69/large/monero_logo.png?1696501460',
  thorchain:
    'https://assets.coingecko.com/coins/images/6595/large/Rune200x200.png?1696506946',
  'rocket-pool-eth':
    'https://assets.coingecko.com/coins/images/20764/large/reth.png?1696520159',
  floki:
    'https://assets.coingecko.com/coins/images/16746/large/PNG_image.png?1696516318',
  'sei-network':
    'https://assets.coingecko.com/coins/images/28205/large/Sei_Logo_-_Transparent.png?1696527207',
  maker:
    'https://assets.coingecko.com/coins/images/1364/large/Mark_Maker.png?1696502423',
  'beam-2':
    'https://assets.coingecko.com/coins/images/32417/large/chain-logo.png?1698114384',
  fantom:
    'https://assets.coingecko.com/coins/images/4001/large/Fantom_round.png?1696504642',
  'bitcoin-cash-sv':
    'https://assets.coingecko.com/coins/images/6799/large/BSV.png?1696507128',
  flow: 'https://assets.coingecko.com/coins/images/13446/large/5f6294c0c7a8cda55cb1c936_Flow_Wordmark.png?1696513210',
  bonk: 'https://assets.coingecko.com/coins/images/28600/large/bonk.jpg?1696527587',
  gala: 'https://assets.coingecko.com/coins/images/12493/large/GALA_token_image_-_200PNG.png?1709725869',
  algorand:
    'https://assets.coingecko.com/coins/images/4380/large/download.png?1696504978',
  dogwifcoin:
    'https://assets.coingecko.com/coins/images/33566/large/dogwifhat.jpg?1702499428',
  'mantle-staked-ether':
    'https://assets.coingecko.com/coins/images/33345/large/symbol_transparent_bg.png?1701697066',
  sui: 'https://assets.coingecko.com/coins/images/26375/large/sui_asset.jpeg?1696525453',
  aave: 'https://assets.coingecko.com/coins/images/12645/large/AAVE.png?1696512452',
  'elrond-erd-2':
    'https://assets.coingecko.com/coins/images/12335/large/egld-token-logo.png?1696512162',
  'axie-infinity':
    'https://assets.coingecko.com/coins/images/13029/large/axie_infinity_logo.png?1696512817',
  starknet:
    'https://assets.coingecko.com/coins/images/26433/large/starknet.png?1696525507',
  'dydx-chain':
    'https://assets.coingecko.com/coins/images/32594/large/dydx.png?1698673495',
  'the-sandbox':
    'https://assets.coingecko.com/coins/images/12129/large/sandbox_logo.jpg?1696511971',
  'quant-network':
    'https://assets.coingecko.com/coins/images/3370/large/5ZOu7brX_400x400.jpg?1696504070',
  bittorrent:
    'https://assets.coingecko.com/coins/images/22457/large/btt_logo.png?1696521780',
  singularitynet:
    'https://assets.coingecko.com/coins/images/2138/large/singularitynet.png?1696503103',
  ordinals:
    'https://assets.coingecko.com/coins/images/30162/large/ordi.png?1696529082',
  'worldcoin-wld':
    'https://assets.coingecko.com/coins/images/31069/large/worldcoin.jpeg?1696529903',
  'mina-protocol':
    'https://assets.coingecko.com/coins/images/15628/large/JM4_vQ34_400x400.png?1696515261',
  'ribbon-finance':
    'https://assets.coingecko.com/coins/images/15823/large/ribbon.png?1709186956',
  'flare-networks':
    'https://assets.coingecko.com/coins/images/28624/large/FLR-icon200x200.png?1696527609',
  decentraland:
    'https://assets.coingecko.com/coins/images/878/large/decentraland-mana.png?1696502010',
  havven:
    'https://assets.coingecko.com/coins/images/3406/large/SNX.png?1696504103',
  'kucoin-shares':
    'https://assets.coingecko.com/coins/images/1047/large/sa9z79.png?1696502152',
  apecoin:
    'https://assets.coingecko.com/coins/images/24383/large/apecoin.jpg?1696523566',
  'akash-network':
    'https://assets.coingecko.com/coins/images/12785/large/akash-logo.png?1696512580',
  chiliz:
    'https://assets.coingecko.com/coins/images/8834/large/CHZ_Token_updated.png?1696508986',
  axelar:
    'https://assets.coingecko.com/coins/images/27277/large/V-65_xQ1_400x400.jpeg?1696526329',
  'sats-ordinals':
    'https://assets.coingecko.com/coins/images/30666/large/_dD8qr3M_400x400.png?1702913020',
  eos: 'https://assets.coingecko.com/coins/images/738/large/eos-eos-logo.png?1696501893',
  'tokenize-xchange':
    'https://assets.coingecko.com/coins/images/4984/large/TKX_-_Logo_-_RGB-15.png?1696505519',
  ecash:
    'https://assets.coingecko.com/coins/images/16646/large/Logo_final-22.png?1696516207',
  helium:
    'https://assets.coingecko.com/coins/images/4284/large/Helium_HNT.png?1696504894',
  tezos:
    'https://assets.coingecko.com/coins/images/976/large/Tezos-logo.png?1696502091',
  'true-usd':
    'https://assets.coingecko.com/coins/images/3449/large/tusd.png?1696504140',
  'conflux-token':
    'https://assets.coingecko.com/coins/images/13079/large/3vuYMbjN.png?1696512867',
  dydx: 'https://assets.coingecko.com/coins/images/17500/large/hjnIm9bV.jpg?1696517040',
  'bitget-token':
    'https://assets.coingecko.com/coins/images/11610/large/icon_colour.png?1696511504',
  neo: 'https://assets.coingecko.com/coins/images/480/large/NEO_512_512.png?1696501735',
  whitebit:
    'https://assets.coingecko.com/coins/images/27045/large/wbt_token.png?1696526096',
  'oasis-network':
    'https://assets.coingecko.com/coins/images/13162/large/rose.png?1696512946',
  ronin:
    'https://assets.coingecko.com/coins/images/20009/large/Ronin_Mark_Blue.png?1707125056',
  'frax-ether':
    'https://assets.coingecko.com/coins/images/28284/large/frxETH_icon.png?1696527284',
  jasmycoin:
    'https://assets.coingecko.com/coins/images/13876/large/JASMY200x200.jpg?1696513620',
  corgiai:
    'https://assets.coingecko.com/coins/images/30933/large/Token.png?1696529775',
  'terra-luna':
    'https://assets.coingecko.com/coins/images/8284/large/01_LunaClassic_color.png?1696508486',
  iota: 'https://assets.coingecko.com/coins/images/692/large/IOTA_Swirl.png?1696501881',
  kava: 'https://assets.coingecko.com/coins/images/9761/large/kava.png?1696509822',
  'wemix-token':
    'https://assets.coingecko.com/coins/images/12998/large/wemixcoin_color_200.png?1696512788',
  gnosis:
    'https://assets.coingecko.com/coins/images/662/large/logo_square_simple_300px.png?1696501854',
  'woo-network':
    'https://assets.coingecko.com/coins/images/12921/large/WOO_Logos_2023_Profile_Pic_WOO.png?1696512709',
  blur: 'https://assets.coingecko.com/coins/images/28453/large/blur.png?1696527448',
  osmosis:
    'https://assets.coingecko.com/coins/images/16724/large/osmo.png?1696516298',
  'pyth-network':
    'https://assets.coingecko.com/coins/images/31924/large/pyth.png?1701245725',
  'nervos-network':
    'https://assets.coingecko.com/coins/images/9566/large/Nervos_White.png?1696509646',
  'jupiter-exchange-solana':
    'https://assets.coingecko.com/coins/images/34188/large/jup.png?1704266489',
  'klay-token':
    'https://assets.coingecko.com/coins/images/9672/large/klaytn.png?1696509742',
  cheelee:
    'https://assets.coingecko.com/coins/images/28573/large/CHEEL_%D1%82%D0%BE%D0%BD%D0%BA%D0%B0%D1%8F_%D0%BE%D0%B1%D0%B2%D0%BE%D0%B4%D0%BA%D0%B0_%283%29.png?1696527561',
  msol: 'https://assets.coingecko.com/coins/images/17752/large/mSOL.png?1696517278',
  dymension:
    'https://assets.coingecko.com/coins/images/34182/large/dym.png?1704253006',
  'bitcoin-gold':
    'https://assets.coingecko.com/coins/images/1043/large/bitcoin-gold-logo.png?1696502150',
  sweth:
    'https://assets.coingecko.com/coins/images/30326/large/_lB7zEtS_400x400.jpg?1696529227',
  'pancakeswap-token':
    'https://assets.coingecko.com/coins/images/12632/large/pancakeswap-cake-logo_%281%29.png?1696512440',
  'curve-dao-token':
    'https://assets.coingecko.com/coins/images/12124/large/Curve.png?1696511967',
  illuvium:
    'https://assets.coingecko.com/coins/images/14468/large/logo-200x200.png?1696514154',
  enjincoin:
    'https://assets.coingecko.com/coins/images/1102/large/Symbol_Only_-_Purple.png?1709725966',
  'manta-network':
    'https://assets.coingecko.com/coins/images/34289/large/manta.jpg?1704468717',
  'ondo-finance':
    'https://assets.coingecko.com/coins/images/26580/large/ONDO.png?1696525656',
  astar:
    'https://assets.coingecko.com/coins/images/22617/large/astr.png?1696521933',
  'ethena-usde':
    'https://assets.coingecko.com/coins/images/33613/large/3466ef_3c088c66c7d941e8856339d0bddf33cc_mv2.png?1702514458',
  'staked-frax-ether':
    'https://assets.coingecko.com/coins/images/28285/large/sfrxETH_icon.png?1696527285',
  'aioz-network':
    'https://assets.coingecko.com/coins/images/14631/large/aioz-logo-200.png?1696514309',
  'ocean-protocol':
    'https://assets.coingecko.com/coins/images/3687/large/ocean-protocol-logo.jpg?1696504363',
  nexo: 'https://assets.coingecko.com/coins/images/3695/large/nexo.png?1696504370',
  'ethereum-name-service':
    'https://assets.coingecko.com/coins/images/19785/large/acatxTm8_400x400.jpg?1696519207',
  'terra-luna-2':
    'https://assets.coingecko.com/coins/images/25767/large/01_Luna_color.png?1696524851',
  'coinbase-wrapped-staked-eth':
    'https://assets.coingecko.com/coins/images/27008/large/cbeth.png?1709186989',
  arkham:
    'https://assets.coingecko.com/coins/images/30929/large/Arkham_Logo_CG.png?1696529771',
  usdd: 'https://assets.coingecko.com/coins/images/25380/large/UUSD.jpg?1696524513',
  holotoken:
    'https://assets.coingecko.com/coins/images/3348/large/Holologo_Profile.png?1696504052',
  '1inch':
    'https://assets.coingecko.com/coins/images/13469/large/1inch-token.png?1696513230',
  'rocket-pool':
    'https://assets.coingecko.com/coins/images/2090/large/rocket_pool_%28RPL%29.png?1696503058',
  'gatechain-token':
    'https://assets.coingecko.com/coins/images/8183/large/gate.png?1696508395',
  livepeer:
    'https://assets.coingecko.com/coins/images/7137/large/logo-circle-green.png?1696507437',
  'frax-share':
    'https://assets.coingecko.com/coins/images/13423/large/Frax_Shares_icon.png?1696513183',
  pixels:
    'https://assets.coingecko.com/coins/images/35100/large/pixel-icon.png?1708339519',
  stepn:
    'https://assets.coingecko.com/coins/images/23597/large/token-gmt-200x200.png?1703153841',
  'lido-staked-sol':
    'https://assets.coingecko.com/coins/images/18369/large/logo_-_2021-09-15T100934.765.png?1696517862',
  'echelon-prime':
    'https://assets.coingecko.com/coins/images/29053/large/prime-logo-small-border_%282%29.png?1696528020',
  golem:
    'https://assets.coingecko.com/coins/images/542/large/Golem_Submark_Positive_RGB.png?1696501761',
  iotex:
    'https://assets.coingecko.com/coins/images/3334/large/iotex-logo.png?1696504041',
  superfarm:
    'https://assets.coingecko.com/coins/images/14040/large/SV-Logo-200x200.png?1706880312',
  apenft:
    'https://assets.coingecko.com/coins/images/15687/large/apenft.jpg?1696515316',
  frax: 'https://assets.coingecko.com/coins/images/13422/large/FRAX_icon.png?1696513182',
  'trust-wallet-token':
    'https://assets.coingecko.com/coins/images/11085/large/Trust.png?1696511026',
  celo: 'https://assets.coingecko.com/coins/images/11090/large/InjXBNx9_400x400.jpg?1696511031',
  siacoin:
    'https://assets.coingecko.com/coins/images/289/large/siacoin.png?1696501638',
  zilliqa:
    'https://assets.coingecko.com/coins/images/2687/large/Zilliqa-logo.png?1696503475',
  coredaoorg:
    'https://assets.coingecko.com/coins/images/28938/large/file_589.jpg?1701868471',
  'xdce-crowd-sale':
    'https://assets.coingecko.com/coins/images/2912/large/xdc-icon.png?1696503661',
  'compound-governance-token':
    'https://assets.coingecko.com/coins/images/10775/large/COMP.png?1696510737',
  altlayer:
    'https://assets.coingecko.com/coins/images/34608/large/altlayer.jpeg?1705497960',
  origintrail:
    'https://assets.coingecko.com/coins/images/1877/large/TRAC.jpg?1696502873',
  'casper-network':
    'https://assets.coingecko.com/coins/images/15279/large/CSPR_Token_Logo_CoinGecko.png?1709518377',
  'theta-fuel':
    'https://assets.coingecko.com/coins/images/8029/large/1_0YusgngOrriVg4ZYx4wOFQ.png?1696508251',
  'metis-token':
    'https://assets.coingecko.com/coins/images/15595/large/Metis_Black_Bg.png?1702968192',
  nosana:
    'https://assets.coingecko.com/coins/images/22553/large/POfb_I4u_400x400.jpg?1696521873',
  '0x': 'https://assets.coingecko.com/coins/images/863/large/0x.png?1696501996',
  dexe: 'https://assets.coingecko.com/coins/images/12713/large/DEXE_token_logo.png?1696512514',
  zetachain:
    'https://assets.coingecko.com/coins/images/26718/large/Twitter_icon.png?1696525788',
  qtum: 'https://assets.coingecko.com/coins/images/684/large/Qtum_Logo_blue_CG.png?1696501874',
  kujira:
    'https://assets.coingecko.com/coins/images/20685/large/kuji-200x200.png?1696520085',
  'tether-gold':
    'https://assets.coingecko.com/coins/images/10481/large/Tether_Gold.png?1696510471',
  fasttoken:
    'https://assets.coingecko.com/coins/images/28478/large/lightenicon_200x200.png?1696527472',
  gmx: 'https://assets.coingecko.com/coins/images/18323/large/arbit.png?1696517814',
  'basic-attention-token':
    'https://assets.coingecko.com/coins/images/677/large/basic-attention-token.png?1696501867',
  'baby-doge-coin':
    'https://assets.coingecko.com/coins/images/16125/large/babydoge.jpg?1696515731',
  skale:
    'https://assets.coingecko.com/coins/images/13245/large/SKALE_token_300x300.png?1696513021',
  'compound-ether':
    'https://assets.coingecko.com/coins/images/10643/large/ceth.png?1696510617',
  'paal-ai':
    'https://assets.coingecko.com/coins/images/30815/large/PaalX.jpg?1696529671',
  'compound-wrapped-btc':
    'https://assets.coingecko.com/coins/images/10823/large/cwbtc.png?1696510780',
  zcash:
    'https://assets.coingecko.com/coins/images/486/large/circle-zcash-color.png?1696501740',
  'mask-network':
    'https://assets.coingecko.com/coins/images/14051/large/Mask_Network.jpg?1696513776',
  chia: 'https://assets.coingecko.com/coins/images/15174/large/zV5K5y9f_400x400.png?1696514829',
  ankr: 'https://assets.coingecko.com/coins/images/4324/large/U85xTl2.png?1696504928',
  'stader-ethx':
    'https://assets.coingecko.com/coins/images/30870/large/staderx.png?1696529717',
  nem: 'https://assets.coingecko.com/coins/images/242/large/NEM_WC_Logo_200px.png?1696501595',
  aelf: 'https://assets.coingecko.com/coins/images/1371/large/aelf-logo.png?1696502429',
  kusama:
    'https://assets.coingecko.com/coins/images/9568/large/m4zRhP5e_400x400.jpg?1696509648',
  kadena:
    'https://assets.coingecko.com/coins/images/3693/large/800_x_800.png?1704378151',
  dash: 'https://assets.coingecko.com/coins/images/19/large/dash-logo.png?1696501423',
  'aleph-zero':
    'https://assets.coingecko.com/coins/images/17212/large/azero-logo_coingecko.png?1698147162',
  gas: 'https://assets.coingecko.com/coins/images/858/large/GAS_512_512.png?1696501992',
  'ethereum-pow-iou':
    'https://assets.coingecko.com/coins/images/26997/large/logo-clear.png?1696526049',
  loopring:
    'https://assets.coingecko.com/coins/images/913/large/LRC.png?1696502034',
  hytopia:
    'https://assets.coingecko.com/coins/images/31283/large/TOPIA-Token-CMC-CG-Compatible.png?1696530106',
  'project-galaxy':
    'https://assets.coingecko.com/coins/images/24530/large/galaxy.jpg?1696523708',
  decred:
    'https://assets.coingecko.com/coins/images/329/large/decred.png?1696501665',
  'portal-2':
    'https://assets.coingecko.com/coins/images/35436/large/portal.jpeg?1708590254',
  harmony:
    'https://assets.coingecko.com/coins/images/4344/large/Y88JAze.png?1696504947',
  'memecoin-2':
    'https://assets.coingecko.com/coins/images/32528/large/memecoin_%282%29.png?1698912168',
  moonbeam:
    'https://assets.coingecko.com/coins/images/22459/large/glmr.png?1696521782',
  radix:
    'https://assets.coingecko.com/coins/images/4374/large/Radix.png?1696504973',
  'xai-blockchain':
    'https://assets.coingecko.com/coins/images/34258/large/2024-01-09_16.31.28.jpg?1704789138',
  biconomy:
    'https://assets.coingecko.com/coins/images/21061/large/biconomy_logo.jpg?1696520444',
  'neutron-3':
    'https://assets.coingecko.com/coins/images/30813/large/ntrn.png?1696529669',
  zelcash:
    'https://assets.coingecko.com/coins/images/5163/large/Flux_symbol_blue-white.png?1696505679',
  'convex-finance':
    'https://assets.coingecko.com/coins/images/15585/large/convex.png?1696515221',
  maga: 'https://assets.coingecko.com/coins/images/31498/large/Maga-Trump-Logo-200px.png?1696530309',
  aragon:
    'https://assets.coingecko.com/coins/images/681/large/Avatar_Circle_x6.png?1696501871',
  'rollbit-coin':
    'https://assets.coingecko.com/coins/images/24552/large/unziL6wO_400x400.jpg?1696523729',
  api3: 'https://assets.coingecko.com/coins/images/13256/large/api3.jpg?1696513031',
  'pax-gold':
    'https://assets.coingecko.com/coins/images/9519/large/paxgold.png?1696509604',
  delysium:
    'https://assets.coingecko.com/coins/images/29299/large/AGI_logo_200.png?1696528251',
  stride:
    'https://assets.coingecko.com/coins/images/27275/large/Stride_Token.png?1696526327',
  deso: 'https://assets.coingecko.com/coins/images/16310/large/deso-logo-refresh-white.png?1696515911',
  '0x0-ai-ai-smart-contract':
    'https://assets.coingecko.com/coins/images/28880/large/0x0.png?1696527857',
  'space-id':
    'https://assets.coingecko.com/coins/images/29468/large/sid_token_logo_%28green2%29.png?1696528413',
  myro: 'https://assets.coingecko.com/coins/images/32878/large/MYRO_200x200.png?1699709942',
  just: 'https://assets.coingecko.com/coins/images/11095/large/JUST.jpg?1696511035',
  'mog-coin':
    'https://assets.coingecko.com/coins/images/31059/large/MOG_LOGO_200x200.png?1696529893',
  sushi:
    'https://assets.coingecko.com/coins/images/12271/large/512x512_Logo_no_chop.png?1696512101',
  'oec-token':
    'https://assets.coingecko.com/coins/images/13708/large/WeChat_Image_20220118095654.png?1696513453',
  ravencoin:
    'https://assets.coingecko.com/coins/images/3412/large/ravencoin.png?1696504108',
  uma: 'https://assets.coingecko.com/coins/images/10951/large/UMA.png?1696510900',
  coti: 'https://assets.coingecko.com/coins/images/2962/large/Coti.png?1696503705',
  audius:
    'https://assets.coingecko.com/coins/images/12913/large/AudiusCoinLogo_2x.png?1696512701',
  'coq-inu':
    'https://assets.coingecko.com/coins/images/33511/large/Coin_CoqInu_1200px.png?1702041053',
  l7dex:
    'https://assets.coingecko.com/coins/images/31801/large/mmexport1694431271547_copy_200x200.jpg?1696530616',
  safepal:
    'https://assets.coingecko.com/coins/images/13905/large/sfp.png?1696513647',
  centrifuge:
    'https://assets.coingecko.com/coins/images/15380/large/centrifuge.PNG?1696515027',
  'threshold-network-token':
    'https://assets.coingecko.com/coins/images/22228/large/nFPNiSbL_400x400.jpg?1696521570',
  magic:
    'https://assets.coingecko.com/coins/images/18623/large/magic.png?1696518095',
  'band-protocol':
    'https://assets.coingecko.com/coins/images/9545/large/Band_token_blue_violet_token.png?1696509627',
  raydium:
    'https://assets.coingecko.com/coins/images/13928/large/PSigc4ie_400x400.jpg?1696513668',
  waves:
    'https://assets.coingecko.com/coins/images/425/large/waves.png?1696501700',
  nxm: 'https://assets.coingecko.com/coins/images/11810/large/NXMmain.png?1696511684',
  guildfi:
    'https://assets.coingecko.com/coins/images/20933/large/guildfi-logo-200.png?1696520322',
  'jito-governance-token':
    'https://assets.coingecko.com/coins/images/33228/large/jto.png?1701137022',
  icon: 'https://assets.coingecko.com/coins/images/1060/large/ICON-symbol-coingecko_latest.png?1706638336',
  'wen-4':
    'https://assets.coingecko.com/coins/images/34856/large/wen-solana.png?1707872119',
  telcoin:
    'https://assets.coingecko.com/coins/images/1899/large/tel.png?1696502892',
  'yearn-finance':
    'https://assets.coingecko.com/coins/images/11849/large/yearn.jpg?1696511720',
  syncus:
    'https://assets.coingecko.com/coins/images/33573/large/Syncus.png?1702450708',
  'vethor-token':
    'https://assets.coingecko.com/coins/images/5230/large/VTHO_Token_Icon.png?1696505735',
  'iexec-rlc':
    'https://assets.coingecko.com/coins/images/646/large/pL1VuXm.png?1696501840',
  'helium-mobile':
    'https://assets.coingecko.com/coins/images/29879/large/Mobile_Icon.png?1696528804',
  chromaway:
    'https://assets.coingecko.com/coins/images/5000/large/Chromia.png?1696505533',
  numeraire:
    'https://assets.coingecko.com/coins/images/752/large/numeraire.png?1696501906',
  wax: 'https://assets.coingecko.com/coins/images/1372/large/WAX_Coin_Tickers_P_512px.png?1696502430',
  'big-time':
    'https://assets.coingecko.com/coins/images/32251/large/-6136155493475923781_121.jpg?1696998691',
  ontology:
    'https://assets.coingecko.com/coins/images/3447/large/ONT.png?1696504138',
  terrausd:
    'https://assets.coingecko.com/coins/images/12681/large/UST.png?1696512486',
  balancer:
    'https://assets.coingecko.com/coins/images/11683/large/Balancer.png?1696511572',
  'yield-guild-games':
    'https://assets.coingecko.com/coins/images/17358/large/Shield_Mark_-_Colored_-_Iridescent.png?1696516909',
  'dao-maker':
    'https://assets.coingecko.com/coins/images/13915/large/4.png?1696513656',
  everipedia:
    'https://assets.coingecko.com/coins/images/5010/large/YAIS3fUh.png?1696505542',
  'benqi-liquid-staked-avax':
    'https://assets.coingecko.com/coins/images/23657/large/savax_blue.png?1696522860',
  lisk: 'https://assets.coingecko.com/coins/images/385/large/Lisk_Symbol_-_Blue.png?1696501687',
  'smooth-love-potion':
    'https://assets.coingecko.com/coins/images/10366/large/SLP.png?1696510368',
  coin98:
    'https://assets.coingecko.com/coins/images/17117/large/logo.png?1696516677',
  'amp-token':
    'https://assets.coingecko.com/coins/images/12409/large/amp-200x200.png?1696512231',
  'synapse-2':
    'https://assets.coingecko.com/coins/images/18024/large/synapse_social_icon.png?1696517540',
  swipe:
    'https://assets.coingecko.com/coins/images/9368/large/swipe.png?1696509466',
  pendle:
    'https://assets.coingecko.com/coins/images/15069/large/Pendle_Logo_Normal-03.png?1696514728',
  'mx-token':
    'https://assets.coingecko.com/coins/images/8545/large/MEXC_GLOBAL_LOGO.jpeg?1696508719',
  cartesi:
    'https://assets.coingecko.com/coins/images/11038/large/Cartesi_Logo.png?1696510982',
  'osaka-protocol':
    'https://assets.coingecko.com/coins/images/30911/large/osak_logo.png?1696529756',
  'bone-shibaswap':
    'https://assets.coingecko.com/coins/images/16916/large/bone_icon.png?1696516487',
  'reserve-rights-token':
    'https://assets.coingecko.com/coins/images/8365/large/rsr.png?1696508558',
  'wrapped-beacon-eth':
    'https://assets.coingecko.com/coins/images/30061/large/wbeth-icon.png?1696528983',
  'oraichain-token':
    'https://assets.coingecko.com/coins/images/12931/large/orai.png?1696512718',
  alexgo:
    'https://assets.coingecko.com/coins/images/25837/large/ALEX_Token.png?1696524922',
  rss3: 'https://assets.coingecko.com/coins/images/23575/large/RSS3.png?1696522783',
  'pocket-network':
    'https://assets.coingecko.com/coins/images/22506/large/POKT.jpg?1703257310',
  'sleepless-ai':
    'https://assets.coingecko.com/coins/images/34011/large/z5d4nRDO_400x400.jpg?1704362731',
  'wrapped-centrifuge':
    'https://assets.coingecko.com/coins/images/17106/large/WCFG.jpg?1696516667',
  'vanar-chain':
    'https://assets.coingecko.com/coins/images/33466/large/apple-touch-icon.png?1701942541',
  polymesh:
    'https://assets.coingecko.com/coins/images/23496/large/Polymesh-symbol.png?1696522706',
  'heroes-of-mavia':
    'https://assets.coingecko.com/coins/images/33895/large/2023-12-20_21.21.41_%281%29.jpg?1703230771',
  marlin:
    'https://assets.coingecko.com/coins/images/8903/large/200x200.png?1706115827',
  'rif-token':
    'https://assets.coingecko.com/coins/images/7460/large/8befc44a46c247e8a3f7fc8abba586b1_%283%29.png?1705501867',
  link: 'https://assets.coingecko.com/coins/images/6450/large/FINSCHIA_coin_icon%28black%29.png?1696506813',
  'seedify-fund':
    'https://assets.coingecko.com/coins/images/14614/large/Favicon_Icon.png?1696514292',
  tellor:
    'https://assets.coingecko.com/coins/images/9644/large/Blk_icon_current.png?1696509713',
  ecomi:
    'https://assets.coingecko.com/coins/images/4428/large/ECOMI.png?1696505023',
  autonolas:
    'https://assets.coingecko.com/coins/images/31099/large/OLAS-token.png?1696529930',
  'ssv-network':
    'https://assets.coingecko.com/coins/images/19155/large/ssv.png?1696518606',
  prometeus:
    'https://assets.coingecko.com/coins/images/8825/large/Ticker.png?1696508978',
  digibyte:
    'https://assets.coingecko.com/coins/images/63/large/digibyte.png?1696501454',
  'bitkub-coin':
    'https://assets.coingecko.com/coins/images/15760/large/KUB.png?1696515385',
  constitutiondao:
    'https://assets.coingecko.com/coins/images/20612/large/GN_UVm3d_400x400.jpg?1696520017',
  'wilder-world':
    'https://assets.coingecko.com/coins/images/15407/large/WILD.png?1696515053',
  beldex:
    'https://assets.coingecko.com/coins/images/5111/large/Beldex.png?1696505631',
  'victoria-vr':
    'https://assets.coingecko.com/coins/images/21178/large/vr.png?1696520554',
  'vvs-finance':
    'https://assets.coingecko.com/coins/images/20210/large/8glAYOTM_400x400.jpg?1696519620',
  'noia-network':
    'https://assets.coingecko.com/coins/images/3269/large/Component_1.png?1696503982',
  'edu-coin':
    'https://assets.coingecko.com/coins/images/29948/large/EDU_Logo.png?1696528874',
  covalent:
    'https://assets.coingecko.com/coins/images/14168/large/cqt_0xd417144312dbf50465b1c641d016962017ef62401705679933563.jpg?1706249001',
  'bitcoin-avalanche-bridged-btc-b':
    'https://assets.coingecko.com/coins/images/26115/large/btcb.png?1696525205',
  tectum:
    'https://assets.coingecko.com/coins/images/29575/large/Icon_TET.png?1696528514',
  swissborg:
    'https://assets.coingecko.com/coins/images/2117/large/YJUrRy7r_400x400.png?1696503083',
  stratis:
    'https://assets.coingecko.com/coins/images/531/large/stratis.png?1696501751',
  'vulcan-forged':
    'https://assets.coingecko.com/coins/images/14770/large/1617088937196.png?1696514439',
  iostoken:
    'https://assets.coingecko.com/coins/images/2523/large/IOST.png?1696503337',
  'mantra-dao':
    'https://assets.coingecko.com/coins/images/12151/large/OM_Token.png?1696511991',
  'tribe-2':
    'https://assets.coingecko.com/coins/images/14575/large/tribe.PNG?1696514256',
  orca: 'https://assets.coingecko.com/coins/images/17547/large/Orca_Logo.png?1696517083',
  'lukso-token-2':
    'https://assets.coingecko.com/coins/images/31010/large/LYX.png?1696529847',
  songbird:
    'https://assets.coingecko.com/coins/images/18663/large/SGB_512x512.png?1696518133',
  'creditcoin-2':
    'https://assets.coingecko.com/coins/images/10569/large/ctc.png?1696510552',
  lcx: 'https://assets.coingecko.com/coins/images/9985/large/zRPSu_0o_400x400.jpg?1696510023',
  blox: 'https://assets.coingecko.com/coins/images/1231/large/Blox_Staking_Logo_2.png?1696502308',
  'constellation-labs':
    'https://assets.coingecko.com/coins/images/4645/large/Constellation_Network_Logo.png?1696505213',
  'humans-ai':
    'https://assets.coingecko.com/coins/images/21273/large/h_logo_1x.png?1696520644',
  oasys:
    'https://assets.coingecko.com/coins/images/27909/large/OAS.png?1696526929',
  myria:
    'https://assets.coingecko.com/coins/images/29273/large/myria.png?1696528226',
  'paypal-usd':
    'https://assets.coingecko.com/coins/images/31212/large/PYUSD_Logo_%282%29.png?1696530039',
  opsec:
    'https://assets.coingecko.com/coins/images/34284/large/IMG_8108.jpeg?1704453267',
  'airtor-protocol':
    'https://assets.coingecko.com/coins/images/29690/large/AirTor.png?1696528623',
  insure:
    'https://assets.coingecko.com/coins/images/10354/large/logo-grey-circle.png?1696510355',
  orbs: 'https://assets.coingecko.com/coins/images/4630/large/Orbs.jpg?1696505200',
  nym: 'https://assets.coingecko.com/coins/images/24488/large/NYM_Token.png?1696523668',
  alephium:
    'https://assets.coingecko.com/coins/images/21598/large/Alephium-Logo_200x200_listing.png?1696520959',
  smardex:
    'https://assets.coingecko.com/coins/images/29470/large/SDEX_logo_transparent_outside_240x240.png?1696930070',
  dent: 'https://assets.coingecko.com/coins/images/1152/large/gLCEA2G.png?1696502243',
  nano: 'https://assets.coingecko.com/coins/images/756/large/nano.png?1696501910',
  bora: 'https://assets.coingecko.com/coins/images/7646/large/mqFw8hxm_400x400.jpeg?1696507900',
  'gains-network':
    'https://assets.coingecko.com/coins/images/19737/large/logo.png?1696519161',
  moonriver:
    'https://assets.coingecko.com/coins/images/17984/large/9285.png?1696517502',
  status:
    'https://assets.coingecko.com/coins/images/779/large/status.png?1696501931',
  syscoin:
    'https://assets.coingecko.com/coins/images/119/large/Syscoin.png?1696501494',
  'power-ledger':
    'https://assets.coingecko.com/coins/images/1104/large/Powerledger_Northstar_colour_digital_%282%29.png?1706702222',
  'paxos-standard':
    'https://assets.coingecko.com/coins/images/6013/large/Pax_Dollar.png?1696506427',
  venus:
    'https://assets.coingecko.com/coins/images/12677/large/download.jpg?1696512482',
  'my-neighbor-alice':
    'https://assets.coingecko.com/coins/images/14375/large/alice_logo.jpg?1696514067',
  coinmetro:
    'https://assets.coingecko.com/coins/images/3125/large/XCM_Token_Logo_.png?1696503850',
  ark: 'https://assets.coingecko.com/coins/images/613/large/ark.png?1696501811',
  'milady-meme-coin':
    'https://assets.coingecko.com/coins/images/30194/large/logo.png?1696529109',
  joe: 'https://assets.coingecko.com/coins/images/17569/large/JoeToken.png?1703732357',
  'hooked-protocol':
    'https://assets.coingecko.com/coins/images/28288/large/hooked2.png?1696527288',
  'dogelon-mars':
    'https://assets.coingecko.com/coins/images/14962/large/6GxcPRo3_400x400.jpg?1696514622',
  hivemapper:
    'https://assets.coingecko.com/coins/images/28388/large/honey.png?1696527388',
  olympus:
    'https://assets.coingecko.com/coins/images/14483/large/token_OHM_%281%29.png?1696514169',
  cudos:
    'https://assets.coingecko.com/coins/images/13651/large/CudosIconTransparent.png?1696513400',
  'nakamoto-games':
    'https://assets.coingecko.com/coins/images/19073/large/flCKDeh6_400x400.jpg?1696518523',
  wink: 'https://assets.coingecko.com/coins/images/9129/large/WinK.png?1696509252',
  zencash:
    'https://assets.coingecko.com/coins/images/691/large/horizen.png?1696501880',
  'genesysgo-shadow':
    'https://assets.coingecko.com/coins/images/22271/large/Property_1_Color.png?1696521615',
  'spell-token':
    'https://assets.coingecko.com/coins/images/15861/large/abracadabra-3.png?1696515477',
  chaingpt:
    'https://assets.coingecko.com/coins/images/29306/large/200x200.png?1696528257',
  hive: 'https://assets.coingecko.com/coins/images/10840/large/logo_transparent_4x.png?1696510797',
  telos:
    'https://assets.coingecko.com/coins/images/7588/large/TLOS.png?1704499537',
  'huobi-token':
    'https://assets.coingecko.com/coins/images/2822/large/huobi-token-logo.png?1696503584',
  chainflip:
    'https://assets.coingecko.com/coins/images/25576/large/kdt_AgmT_400x400.png?1696524709',
  'celer-network':
    'https://assets.coingecko.com/coins/images/4379/large/Celr.png?1696504978',
  secret:
    'https://assets.coingecko.com/coins/images/11871/large/secret_logo.png?1696511740',
  'huobi-btc':
    'https://assets.coingecko.com/coins/images/12407/large/hbtc.png?1696512229',
  'xyo-network':
    'https://assets.coingecko.com/coins/images/4519/large/XYO_Network-logo.png?1696505103',
  cortex:
    'https://assets.coingecko.com/coins/images/3861/large/2638.png?1696504523',
  'phoenix-global':
    'https://assets.coingecko.com/coins/images/20052/large/Phoenix_logo_blue_bird.png?1696519471',
  arcblock:
    'https://assets.coingecko.com/coins/images/2341/large/arcblock.png?1696503220',
  'metars-genesis':
    'https://assets.coingecko.com/coins/images/26625/large/PRmUU8O1_400x400.jpeg?1696525698',
  pandora:
    'https://assets.coingecko.com/coins/images/34996/large/PandoraToken.png?1706954340',
  pepefork:
    'https://assets.coingecko.com/coins/images/34913/large/pork.png?1706606047',
  popcat:
    'https://assets.coingecko.com/coins/images/33760/large/image.jpg?1702964227',
  'pundi-x-2':
    'https://assets.coingecko.com/coins/images/14571/large/vDyefsXq_400x400.jpg?1696514252',
  hashflow:
    'https://assets.coingecko.com/coins/images/26136/large/hashflow-icon-cmc.png?1696525224',
  gelato:
    'https://assets.coingecko.com/coins/images/15026/large/Gelato_Icon_Logo_1024x1024.png?1696514687',
  tenset:
    'https://assets.coingecko.com/coins/images/14629/large/PNG_Tenset_Sign-back_RGB.png?1696514307',
  auction:
    'https://assets.coingecko.com/coins/images/13860/large/1_KtgpRIJzuwfHe0Rl0avP_g.jpeg?1696513606',
  liquity:
    'https://assets.coingecko.com/coins/images/14665/large/200-lqty-icon.png?1696514340',
  'origin-ether':
    'https://assets.coingecko.com/coins/images/29733/large/OETH.png?1696528663',
  'agoras-currency-of-tau':
    'https://assets.coingecko.com/coins/images/399/large/agrs.png?1696501692',
  'radiant-capital':
    'https://assets.coingecko.com/coins/images/26536/large/Radiant-Logo-200x200.png?1696525610',
  'alpha-finance':
    'https://assets.coingecko.com/coins/images/12738/large/Stella200x200-06.png?1696512537',
  dodo: 'https://assets.coingecko.com/coins/images/12651/large/dodo_logo.png?1696512458',
  'stader-maticx':
    'https://assets.coingecko.com/coins/images/25383/large/maticx.png?1696524516',
  'trias-token':
    'https://assets.coingecko.com/coins/images/13963/large/5ELqtwp__400x400_%281%29.jpg?1696513699',
  'aerodrome-finance':
    'https://assets.coingecko.com/coins/images/31745/large/token.png?1696530564',
  omisego:
    'https://assets.coingecko.com/coins/images/776/large/OMG_Network.jpg?1696501928',
  'alchemix-usd':
    'https://assets.coingecko.com/coins/images/14114/large/Alchemix_USD.png?1696513835',
  looksrare:
    'https://assets.coingecko.com/coins/images/22173/large/circle-black-256.png?1696521517',
  'mass-vehicle-ledger':
    'https://assets.coingecko.com/coins/images/3476/large/mass-vehicle-ledger.png?1696504164',
  'dusk-network':
    'https://assets.coingecko.com/coins/images/5217/large/image_widget_biddfvxd454b1.png?1696505726',
  'arbdoge-ai':
    'https://assets.coingecko.com/coins/images/29852/large/photo_2023-04-18_14-25-28.jpg?1696528778',
  'alchemy-pay':
    'https://assets.coingecko.com/coins/images/12390/large/ACH_%281%29.png?1696512213',
  dkargo:
    'https://assets.coingecko.com/coins/images/11875/large/bVD0g0dlmrEOPIkt943KZIBZ086eCshyY0jIQFti4zxYdOlFltU8tKa6uJlcA14HvNjX4bc7dxdMvlpoW5NFMND85oG4aiiCbFRhI6eowDfKEBY3BoSVY0IrBbA9SFGIxh_IYrkNC5uNdG-roZ0_TlGO3098now6Tbzga0p4IDqVk6lnaX3TuRC7pgnAYWZM15RD-uEIHr3O_3OoIIWP-.jpg?1696511743',
  'shrapnel-2':
    'https://assets.coingecko.com/coins/images/32793/large/shrapnel.png?1699441661',
  'sun-token':
    'https://assets.coingecko.com/coins/images/12424/large/RSFOmQ.png?1696512245',
  'crown-by-third-time-games':
    'https://assets.coingecko.com/coins/images/30452/large/crown_200_transparent.png?1696529338',
  ergo: 'https://assets.coingecko.com/coins/images/2484/large/Ergo.png?1696503303',
  steem:
    'https://assets.coingecko.com/coins/images/398/large/steem.png?1696501691',
  ong: 'https://assets.coingecko.com/coins/images/5716/large/ONG_logo.png?1696506172',
  zignaly:
    'https://assets.coingecko.com/coins/images/14796/large/zignaly.jpg?1704292004',
  'milk-alliance':
    'https://assets.coingecko.com/coins/images/11978/large/2.png?1696511836',
  'maverick-protocol':
    'https://assets.coingecko.com/coins/images/30850/large/MAV_Logo.png?1696529701',
  medibloc:
    'https://assets.coingecko.com/coins/images/1374/large/medibloc_basic.png?1696502431',
  ampleforth:
    'https://assets.coingecko.com/coins/images/4708/large/Ampleforth.png?1696505273',
  crvusd:
    'https://assets.coingecko.com/coins/images/30118/large/crvusd.jpeg?1696529040',
  metal:
    'https://assets.coingecko.com/coins/images/763/large/Metal.png?1696501916',
  snek: 'https://assets.coingecko.com/coins/images/30496/large/snek_icon_200.png?1703346174',
  'kyber-network-crystal':
    'https://assets.coingecko.com/coins/images/14899/large/RwdVsGcw_400x400.jpg?1696514562',
  'stargate-finance':
    'https://assets.coingecko.com/coins/images/24413/large/STG_LOGO.png?1696523595',
  bluzelle:
    'https://assets.coingecko.com/coins/images/2848/large/ColorIcon_3x.png?1696503607',
  'alethea-artificial-liquid-intelligence-token':
    'https://assets.coingecko.com/coins/images/22062/large/Logo_Circle_720_%281%29.png?1696521405',
  mobox:
    'https://assets.coingecko.com/coins/images/14751/large/mobox.PNG?1696514420',
  wazirx:
    'https://assets.coingecko.com/coins/images/10547/large/WazirX.png?1696510532',
  'apex-token-2':
    'https://assets.coingecko.com/coins/images/25266/large/CxpMECpk_400x400_%281%29.png?1696524406',
  'the-doge-nft':
    'https://assets.coingecko.com/coins/images/18111/large/Doge.png?1696517615',
  'gemini-dollar':
    'https://assets.coingecko.com/coins/images/5992/large/gemini-dollar-gusd.png?1696506408',
  'stp-network':
    'https://assets.coingecko.com/coins/images/8713/large/STP.png?1696508875',
  redacted:
    'https://assets.coingecko.com/coins/images/26745/large/redacted_v2.jpg?1696525813',
  verasity:
    'https://assets.coingecko.com/coins/images/14025/large/VRA.jpg?1696513752',
  gitcoin:
    'https://assets.coingecko.com/coins/images/15810/large/gitcoin.png?1696515429',
  'energy-web-token':
    'https://assets.coingecko.com/coins/images/10886/large/R9gQTJV__400x400.png?1696510839',
  'btse-token':
    'https://assets.coingecko.com/coins/images/10807/large/BTSE_logo_Square.jpeg?1696510765',
  ultima:
    'https://assets.coingecko.com/coins/images/31844/large/ULTIMA.jpg?1696530658',
  maple:
    'https://assets.coingecko.com/coins/images/14097/large/Maple_Logo_Mark_Maple_Orange.png?1696513819',
  'palm-ai':
    'https://assets.coingecko.com/coins/images/33097/large/PalmProfile01Artboard_6_2x.png?1703862864',
  vaiot:
    'https://assets.coingecko.com/coins/images/13981/large/VAIOT_logo.png?1696513714',
  'world-mobile-token':
    'https://assets.coingecko.com/coins/images/17333/large/Colored_Token.png?1696516885',
  'loom-network-new':
    'https://assets.coingecko.com/coins/images/14735/large/LOOM.png?1696514405',
  'gmt-token':
    'https://assets.coingecko.com/coins/images/15662/large/gmt.png?1696515292',
  'chex-token':
    'https://assets.coingecko.com/coins/images/10349/large/logo-dark-200.png?1701121978',
  'stasis-eurs':
    'https://assets.coingecko.com/coins/images/5164/large/EURS_300x300.png?1696505680',
  'commune-ai':
    'https://assets.coingecko.com/coins/images/35013/large/Wrapped_Commune_AI.png?1707103767',
  pha: 'https://assets.coingecko.com/coins/images/12451/large/phala.png?1696512270',
  'fx-coin':
    'https://assets.coingecko.com/coins/images/8186/large/47271330_590071468072434_707260356350705664_n.jpg?1696508396',
  'aurora-near':
    'https://assets.coingecko.com/coins/images/20582/large/aurora.jpeg?1696519989',
  'tokamak-network':
    'https://assets.coingecko.com/coins/images/12260/large/D919x5-s_400x400.png?1696512091',
  'liquity-usd':
    'https://assets.coingecko.com/coins/images/14666/large/Group_3.png?1696514341',
  'adventure-gold':
    'https://assets.coingecko.com/coins/images/18125/large/lpgblc4h_400x400.jpg?1696517628',
  'dora-factory-2':
    'https://assets.coingecko.com/coins/images/31552/large/DORA.jpg?1696530364',
  nkn: 'https://assets.coingecko.com/coins/images/3375/large/nkn.png?1696504074',
  'polygon-ecosystem-token':
    'https://assets.coingecko.com/coins/images/32440/large/polygon.png?1698233684',
  acala:
    'https://assets.coingecko.com/coins/images/20634/large/upOKBONH_400x400.jpg?1696520038',
  euler:
    'https://assets.coingecko.com/coins/images/26149/large/Coingecko_logo_%281%29.png?1706026067',
  gamefi:
    'https://assets.coingecko.com/coins/images/18292/large/gamefi.PNG?1696517784',
  xpla: 'https://assets.coingecko.com/coins/images/27925/large/xpla.png?1696526945',
  'merit-circle':
    'https://assets.coingecko.com/coins/images/19304/large/Db4XqML.png?1696518747',
  'platon-network':
    'https://assets.coingecko.com/coins/images/15430/large/PlatON-Black.png?1696515075',
  bancor:
    'https://assets.coingecko.com/coins/images/736/large/bancor-bnt.png?1696501892',
  'radio-caca':
    'https://assets.coingecko.com/coins/images/17841/large/ez44_BSs_400x400.jpg?1696517365',
  noisegpt:
    'https://assets.coingecko.com/coins/images/29908/large/icon.png?1702507913',
  gamercoin:
    'https://assets.coingecko.com/coins/images/14714/large/ghx_icon.png?1696514385',
  canto:
    'https://assets.coingecko.com/coins/images/26959/large/canto-network.png?1696526014',
  multibit:
    'https://assets.coingecko.com/coins/images/33051/large/multi.jpg?1700473994',
  'bitrise-token':
    'https://assets.coingecko.com/coins/images/17388/large/200x200.png?1696516937',
  cyberconnect:
    'https://assets.coingecko.com/coins/images/31274/large/cyberconnect.png?1696530098',
  wexo: 'https://assets.coingecko.com/coins/images/33801/large/wexo_token_200x200.png?1702991908',
  'star-atlas':
    'https://assets.coingecko.com/coins/images/17659/large/Icon_Reverse.png?1696517190',
  'access-protocol':
    'https://assets.coingecko.com/coins/images/28747/large/dR4FovX4_400x400.jpg?1696527727',
  'guild-of-guardians':
    'https://assets.coingecko.com/coins/images/17362/large/V2QDNoLg_400x400.jpg?1696516913',
  storm:
    'https://assets.coingecko.com/coins/images/1369/large/StormX.png?1696502427',
  storj:
    'https://assets.coingecko.com/coins/images/949/large/storj.png?1696502065',
  bakerytoken:
    'https://assets.coingecko.com/coins/images/12588/large/bakerytoken_logo.jpg?1696512398',
  'gods-unchained':
    'https://assets.coingecko.com/coins/images/17139/large/10631.png?1696516698',
  radicle:
    'https://assets.coingecko.com/coins/images/14013/large/radicle.png?1696513741',
  tominet:
    'https://assets.coingecko.com/coins/images/28730/large/logo_for_token.png?1696527710',
  goldfinch:
    'https://assets.coingecko.com/coins/images/19081/large/GOLDFINCH.png?1696518531',
  ardor:
    'https://assets.coingecko.com/coins/images/525/large/Ardor_Vertical_1.png?1696501746',
  sweatcoin:
    'https://assets.coingecko.com/coins/images/25057/large/fhD9Xs16_400x400.jpg?1696524208',
  'lyra-finance':
    'https://assets.coingecko.com/coins/images/21490/large/Add-a-heading-26.png?1696520850',
  'clore-ai':
    'https://assets.coingecko.com/coins/images/30959/large/CLORE_Logo_200x200_PNG.png?1696529798',
  'celsius-degree-token':
    'https://assets.coingecko.com/coins/images/3263/large/CEL_logo.png?1696503976',
  'lukso-token':
    'https://assets.coingecko.com/coins/images/11423/large/LYX.png?1696511335',
  'perpetual-protocol':
    'https://assets.coingecko.com/coins/images/12381/large/60d18e06844a844ad75901a9_mark_only_03.png?1696512205',
  certik:
    'https://assets.coingecko.com/coins/images/12944/large/shentu_2.jpg?1696512733',
  'badger-dao':
    'https://assets.coingecko.com/coins/images/13287/large/badger_dao_logo.jpg?1696513059',
  unizen:
    'https://assets.coingecko.com/coins/images/14830/large/logo128px.png?1700169101',
  'origin-protocol':
    'https://assets.coingecko.com/coins/images/3296/large/op.jpg?1696504006',
  playdapp:
    'https://assets.coingecko.com/coins/images/14316/large/54023228.png?1696514005',
  'alien-worlds':
    'https://assets.coingecko.com/coins/images/14676/large/kY-C4o7RThfWrDQsLCAG4q4clZhBDDfJQVhWUEKxXAzyQYMj4Jmq1zmFwpRqxhAJFPOa0AsW_PTSshoPuMnXNwq3rU7Imp15QimXTjlXMx0nC088mt1rIwRs75GnLLugWjSllxgzvQ9YrP4tBgclK4_rb17hjnusGj_c0u2fx0AvVokjSNB-v2poTj0xT9BZRCbzRE3-lF1.jpg?1696514350',
  civic:
    'https://assets.coingecko.com/coins/images/788/large/civic-orange.png?1696501939',
  'ethernity-chain':
    'https://assets.coingecko.com/coins/images/14238/large/LOGO_HIGH_QUALITY.png?1696513952',
  'allianceblock-nexera':
    'https://assets.coingecko.com/coins/images/29181/large/nxra.png?1696528139',
  'open-exchange-token':
    'https://assets.coingecko.com/coins/images/30604/large/Logo2.png?1696529473',
  idia: 'https://assets.coingecko.com/coins/images/17803/large/IDIA.png?1696517325',
  dimo: 'https://assets.coingecko.com/coins/images/28383/large/Token_Logo.png?1696527383',
  moviebloc:
    'https://assets.coingecko.com/coins/images/8460/large/MBL_Logo.png?1696508646',
  'coinex-token':
    'https://assets.coingecko.com/coins/images/4817/large/coinex-token.png?1696505367',
  'request-network':
    'https://assets.coingecko.com/coins/images/1031/large/Request_icon_green.png?1696502140',
  tor: 'https://assets.coingecko.com/coins/images/23609/large/tor.png?1696522816',
  humanscape:
    'https://assets.coingecko.com/coins/images/4243/large/Hippocrat_Token_Logo_ver.1.0.jpg?1707157531',
  zkfair:
    'https://assets.coingecko.com/coins/images/34288/large/r8A3J3kf_400x400.jpg?1704455147',
  saucerswap:
    'https://assets.coingecko.com/coins/images/27401/large/saucerswap.png?1700385139',
  'solidus-aitech':
    'https://assets.coingecko.com/coins/images/22114/large/CMC_200x200_AITECH.png?1696521456',
  'ordiswap-token':
    'https://assets.coingecko.com/coins/images/33910/large/IMG-20240113-WA0018.jpg.jpg?1705169306',
  bilira:
    'https://assets.coingecko.com/coins/images/10119/large/JBs9jiXO_400x400.jpg?1696510144',
  'saitama-inu':
    'https://assets.coingecko.com/coins/images/16353/large/SOIKDUWf_400x400.jpeg?1696515952',
  polymath:
    'https://assets.coingecko.com/coins/images/2784/large/inKkF01.png?1696503553',
  'star-atlas-dao':
    'https://assets.coingecko.com/coins/images/17789/large/POLIS.jpg?1696517312',
  'across-protocol':
    'https://assets.coingecko.com/coins/images/28161/large/across-200x200.png?1696527165',
  ultra:
    'https://assets.coingecko.com/coins/images/4480/large/Ultra.png?1696505069',
  shardus:
    'https://assets.coingecko.com/coins/images/8383/large/final_logo_photoshop.png?1696508575',
  'numbers-protocol':
    'https://assets.coingecko.com/coins/images/20495/large/NP_Social_media_profile_pic.png?1696519902',
  arc: 'https://assets.coingecko.com/coins/images/24235/large/arc.png?1696523420',
  tbtc: 'https://assets.coingecko.com/coins/images/11224/large/0x18084fba666a33d37592fa2633fd49a74dd93a88.png?1696511155',
  superrare:
    'https://assets.coingecko.com/coins/images/17753/large/RARE.png?1709598473',
  electroneum:
    'https://assets.coingecko.com/coins/images/1109/large/electroneum.png?1696502205',
  stratos:
    'https://assets.coingecko.com/coins/images/16213/large/token_512x512.png?1696515814',
  bazaars:
    'https://assets.coingecko.com/coins/images/26392/large/bazaars_logo-color-black-icon.png?1696525469',
  tokenfi:
    'https://assets.coingecko.com/coins/images/32507/large/MAIN_TokenFi_logo_icon.png?1698918427',
  bifrost:
    'https://assets.coingecko.com/coins/images/4639/large/BFC_Symbol.png?1696505208',
  benqi:
    'https://assets.coingecko.com/coins/images/16362/large/GergDDN3_400x400.jpg?1696515961',
  singularitydao:
    'https://assets.coingecko.com/coins/images/15385/large/200x200_logo.png?1696515032',
  'welsh-corgi-coin':
    'https://assets.coingecko.com/coins/images/34009/large/welsh.png?1703668279',
  neon: 'https://assets.coingecko.com/coins/images/28331/large/neon_%281%29.png?1696527338',
  'compound-usd-coin':
    'https://assets.coingecko.com/coins/images/9442/large/Compound_USDC.png?1696509534',
  'quark-chain':
    'https://assets.coingecko.com/coins/images/3849/large/quarkchain.png?1696504513',
  marblex:
    'https://assets.coingecko.com/coins/images/24423/large/AgYzKzLt_400x400.jpg?1696523604',
  verge:
    'https://assets.coingecko.com/coins/images/203/large/Verge_Coin_%28native%29_icon_200x200.jpg?1699220755',
  dynex:
    'https://assets.coingecko.com/coins/images/27776/large/Transparent_Logo.png?1696526797',
  stargaze:
    'https://assets.coingecko.com/coins/images/22363/large/stargaze_star_pink.png?1708079583',
  everscale:
    'https://assets.coingecko.com/coins/images/12783/large/everscale_badge_main_round_1x.png?1696512578',
  mimblewimblecoin:
    'https://assets.coingecko.com/coins/images/9989/large/E5zZUXza_400x400.jpg?1696510026',
  trac: 'https://assets.coingecko.com/coins/images/30288/large/Trac_Coingecko.png?1702946961',
  agoric:
    'https://assets.coingecko.com/coins/images/24487/large/agoric_bld_logo.png?1696523668',
  metadium:
    'https://assets.coingecko.com/coins/images/5247/large/META_Logo_black.png?1696505751',
  'uquid-coin':
    'https://assets.coingecko.com/coins/images/1341/large/uquid-coin.png?1696502403',
  'hunt-token':
    'https://assets.coingecko.com/coins/images/7989/large/HUNT.png?1696508215',
  zmine:
    'https://assets.coingecko.com/coins/images/2103/large/zmn.png?1696503070',
  usdx: 'https://assets.coingecko.com/coins/images/13056/large/USDX_coin.png?1696512841',
  'cobak-token':
    'https://assets.coingecko.com/coins/images/13459/large/cbk-128-128.png?1696513222',
  polkastarter:
    'https://assets.coingecko.com/coins/images/12648/large/polkastarter.png?1696512455',
  'kondux-v2':
    'https://assets.coingecko.com/coins/images/28244/large/kndx.png?1696527247',
  'keep-network':
    'https://assets.coingecko.com/coins/images/3373/large/IuNzUb5b_400x400.jpg?1696504072',
  'synesis-one':
    'https://assets.coingecko.com/coins/images/23289/large/sns.png?1696522507',
  'astroport-fi':
    'https://assets.coingecko.com/coins/images/26309/large/Astroport_Circle_Icon_400x400.png?1696525392',
  'ait-protocol':
    'https://assets.coingecko.com/coins/images/33962/large/ait-logo-200x200.png?1703567800',
  'wrapped-nxm':
    'https://assets.coingecko.com/coins/images/11890/large/wNXM.png?1696511757',
  'kinesis-gold':
    'https://assets.coingecko.com/coins/images/29788/large/kau-currency-ticker.png?1696528718',
  'republic-protocol':
    'https://assets.coingecko.com/coins/images/3139/large/REN.png?1696503862',
  'hifi-finance':
    'https://assets.coingecko.com/coins/images/28712/large/hft.png?1696527693',
  'boba-network':
    'https://assets.coingecko.com/coins/images/20285/large/Boba-200x200---white.png?1696519690',
  'loom-network':
    'https://assets.coingecko.com/coins/images/3387/large/1_K76UVoLq-FOL7l-_Fag-Qw_2x.png?1696504085',
  gearbox:
    'https://assets.coingecko.com/coins/images/21630/large/gear.png?1696520990',
  'zebec-protocol':
    'https://assets.coingecko.com/coins/images/24342/large/zebec.jpeg?1696523526',
  'orchid-protocol':
    'https://assets.coingecko.com/coins/images/3916/large/download_%285%29.png?1696504574',
  seth2:
    'https://assets.coingecko.com/coins/images/16569/large/emerald256.png?1696516130',
  toshi:
    'https://assets.coingecko.com/coins/images/31126/large/2023-08-11_13.21.24.png?1697025145',
  truefi:
    'https://assets.coingecko.com/coins/images/13180/large/truefi_glyph_color.png?1696512963',
  turbo:
    'https://assets.coingecko.com/coins/images/30117/large/TurboMark-QL_200.png?1708079597',
  dextools:
    'https://assets.coingecko.com/coins/images/11603/large/dext.png?1696511498',
  elastos:
    'https://assets.coingecko.com/coins/images/2780/large/Elastos.png?1696503549',
  'krypton-dao':
    'https://assets.coingecko.com/coins/images/25467/large/krd.png?1696524597',
  'cow-protocol':
    'https://assets.coingecko.com/coins/images/24384/large/cow.png?1696523567',
  carry:
    'https://assets.coingecko.com/coins/images/3994/large/Carry.png?1696504635',
  'cheqd-network':
    'https://assets.coingecko.com/coins/images/20855/large/CHEQ.png?1706906858',
  ankreth:
    'https://assets.coingecko.com/coins/images/13403/large/aETHc.png?1696513165',
  'cocos-bcx':
    'https://assets.coingecko.com/coins/images/4932/large/COMBO.jpg?1696505472',
  'kinesis-silver':
    'https://assets.coingecko.com/coins/images/29789/large/kag-currency-ticker.png?1696528719',
  tomochain:
    'https://assets.coingecko.com/coins/images/3416/large/viction.jpeg?1698894318',
  'chainge-finance':
    'https://assets.coingecko.com/coins/images/16526/large/chainge.jpeg?1708099639',
  vitadao:
    'https://assets.coingecko.com/coins/images/16580/large/QmRjwywiAfpzSfQTuWM3zCTghSHN7G6ohQaar7Ht6WANUp.png?1696516140',
  xana: 'https://assets.coingecko.com/coins/images/24379/large/XANA_Logo_neon_pink.png?1696523562',
  pangolin:
    'https://assets.coingecko.com/coins/images/14023/large/PNG_token.png?1696513750',
  'binance-usd':
    'https://assets.coingecko.com/coins/images/9576/large/BUSDLOGO.jpg?1696509654',
  defichain:
    'https://assets.coingecko.com/coins/images/11757/large/symbol-defi-blockchain_200.png?1696511638',
  'yes-money':
    'https://assets.coingecko.com/coins/images/35657/large/yes-money.jpeg?1709437181',
  linear:
    'https://assets.coingecko.com/coins/images/12509/large/1649227343-linalogo200px.png?1696512324',
  'ozone-chain':
    'https://assets.coingecko.com/coins/images/31385/large/ozonechain-momogram-200x200.png?1696530201',
  'beta-finance':
    'https://assets.coingecko.com/coins/images/18715/large/beta_finance.jpg?1696518183',
  'rally-2':
    'https://assets.coingecko.com/coins/images/12843/large/image.png?1696512633',
  'prisma-mkusd':
    'https://assets.coingecko.com/coins/images/31519/large/mkUSD_200.png?1696530329',
  qanplatform:
    'https://assets.coingecko.com/coins/images/15977/large/qanx.png?1696515591',
  persistence:
    'https://assets.coingecko.com/coins/images/14582/large/512_Light.png?1696514262',
  'grape-2-2':
    'https://assets.coingecko.com/coins/images/31106/large/grape_logo-removebg-preview_%281%29.png?1696529937',
  'paid-network':
    'https://assets.coingecko.com/coins/images/13761/large/512.png?1696513503',
  sovryn:
    'https://assets.coingecko.com/coins/images/16248/large/sovryn_logo_orange.png?1709174299',
  lever:
    'https://assets.coingecko.com/coins/images/26205/large/WI72SpBl_400x400.jpeg?1696525291',
  aventus:
    'https://assets.coingecko.com/coins/images/901/large/1673958879448.jpeg?1696502024',
  'measurable-data-token':
    'https://assets.coingecko.com/coins/images/2441/large/mdt_logo.png?1696503273',
  unibot:
    'https://assets.coingecko.com/coins/images/30462/large/logonoline_%281%29.png?1696529349',
  leash:
    'https://assets.coingecko.com/coins/images/15802/large/Leash.png?1696515425',
  alchemix:
    'https://assets.coingecko.com/coins/images/14113/large/Alchemix.png?1696513834',
  tokenlon:
    'https://assets.coingecko.com/coins/images/13454/large/lon_logo.png?1696513217',
  aergo:
    'https://assets.coingecko.com/coins/images/4490/large/aergo.png?1696505079',
  litentry:
    'https://assets.coingecko.com/coins/images/13825/large/logo_200x200.png?1696513568',
  automata:
    'https://assets.coingecko.com/coins/images/15985/large/ATA.jpg?1696515598',
  'short-term-t-bill-token':
    'https://assets.coingecko.com/coins/images/29239/large/STBT_icon.png?1696528196',
  'quasar-2':
    'https://assets.coingecko.com/coins/images/30995/large/LOGO.png?1696529833',
  'banana-gun':
    'https://assets.coingecko.com/coins/images/31744/large/bgg.jpeg?1696530563',
  marinade:
    'https://assets.coingecko.com/coins/images/18867/large/MNDE.png?1696518327',
  'green-satoshi-token':
    'https://assets.coingecko.com/coins/images/21841/large/gst.png?1696521196',
  'escoin-token':
    'https://assets.coingecko.com/coins/images/13566/large/escoin-200.png?1696513320',
  arpa: 'https://assets.coingecko.com/coins/images/8506/large/9u0a23XY_400x400.jpg?1696508685',
  satoshivm:
    'https://assets.coingecko.com/coins/images/34659/large/SatoshiVM.jpeg?1705635248',
  opulous:
    'https://assets.coingecko.com/coins/images/16548/large/opulous.PNG?1696516110',
  'silly-dragon':
    'https://assets.coingecko.com/coins/images/33698/large/image.png?1702821846',
  'planet-token':
    'https://assets.coingecko.com/coins/images/30767/large/Logo-Planet.png?1696529635',
  hopr: 'https://assets.coingecko.com/coins/images/14061/large/Shared_HOPR_logo_512px.png?1696513786',
  cornucopias:
    'https://assets.coingecko.com/coins/images/21452/large/g56WwJDA_400x400.jpg?1696520814',
  'ondo-us-dollar-yield':
    'https://assets.coingecko.com/coins/images/31700/large/usdy_%281%29.png?1696530524',
  meter:
    'https://assets.coingecko.com/coins/images/11848/large/meter.png?1696511719',
  marcopolo:
    'https://assets.coingecko.com/coins/images/10085/large/53819931.png?1696510114',
  samoyedcoin:
    'https://assets.coingecko.com/coins/images/15051/large/IXeEj5e.png?1696514710',
  paraswap:
    'https://assets.coingecko.com/coins/images/20403/large/ep7GqM19_400x400.jpg?1696519812',
  biswap:
    'https://assets.coingecko.com/coins/images/16845/large/biswap.png?1696516413',
  'flamingo-finance':
    'https://assets.coingecko.com/coins/images/12618/large/flamingo_finance_logo.jpg?1696512425',
  gxchain:
    'https://assets.coingecko.com/coins/images/1089/large/26296223.png?1696502189',
  'cere-network':
    'https://assets.coingecko.com/coins/images/20008/large/cere.png?1696519430',
  aleph:
    'https://assets.coingecko.com/coins/images/11676/large/Aleph-Logo-BW.png?1696511566',
  solend:
    'https://assets.coingecko.com/coins/images/19573/large/i6AMOwun_400x400.jpg?1696519005',
  microvisionchain:
    'https://assets.coingecko.com/coins/images/29490/large/space.png?1696528434',
  'shapeshift-fox-token':
    'https://assets.coingecko.com/coins/images/9988/large/FOX.png?1696510025',
  strike:
    'https://assets.coingecko.com/coins/images/14607/large/Jw-36llq_400x400.jpg?1696514286',
  'vertex-protocol':
    'https://assets.coingecko.com/coins/images/27927/large/vrtx.png?1696526947',
  cdai: 'https://assets.coingecko.com/coins/images/9281/large/cDAI.png?1696509390',
  'zephyr-protocol':
    'https://assets.coingecko.com/coins/images/30865/large/ZephyrLogo200x200.png?1696529712',
  mainframe:
    'https://assets.coingecko.com/coins/images/3293/large/Mainframe_Token_Logo.png?1696504003',
  'hermez-network-token':
    'https://assets.coingecko.com/coins/images/12826/large/hermez_logo.png?1696512617',
  'a-hunters-dream':
    'https://assets.coingecko.com/coins/images/25130/large/x-Logo-color-10x.png?1696524280',
  'veno-finance':
    'https://assets.coingecko.com/coins/images/28799/large/Veno_Token_dark.png?1696527777',
  'vyvo-smart-chain':
    'https://assets.coingecko.com/coins/images/32105/large/Vyvo.png?1696530902',
  hydradx:
    'https://assets.coingecko.com/coins/images/13929/large/hydradx_logo.png?1696513669',
  inspect:
    'https://assets.coingecko.com/coins/images/33422/large/200_%281%29.png?1701767509',
  route:
    'https://assets.coingecko.com/coins/images/13709/large/route_token_200x200-19.png?1696513454',
  reef: 'https://assets.coingecko.com/coins/images/13504/large/Group_10572.png?1696513266',
  'xcad-network':
    'https://assets.coingecko.com/coins/images/15857/large/xcad_logo.jpg?1707832192',
  lif3: 'https://assets.coingecko.com/coins/images/26007/large/LIF3.png?1696525084',
  forta:
    'https://assets.coingecko.com/coins/images/25060/large/Forta_lgo_%281%29.png?1696524210',
  ztx: 'https://assets.coingecko.com/coins/images/32340/large/CoinGecko_200_x_200.jpg?1697466589',
  'altered-state-token':
    'https://assets.coingecko.com/coins/images/24893/large/ASTO.png?1696524051',
  firmachain:
    'https://assets.coingecko.com/coins/images/9892/large/6mHcLurm_400x400.jpg?1696509941',
  'trufin-staked-matic':
    'https://assets.coingecko.com/coins/images/32416/large/TruMATIC_logo_250px_%281%29.png?1698114190',
  'steem-dollars':
    'https://assets.coingecko.com/coins/images/652/large/steem_dollars.png?1696501846',
  coinweb:
    'https://assets.coingecko.com/coins/images/21607/large/Logo_200x200.png?1696520967',
  'dejitaru-tsuka':
    'https://assets.coingecko.com/coins/images/26405/large/Dejitaru_Tsuka_Logo.jpg?1696525481',
  'aurora-dao':
    'https://assets.coingecko.com/coins/images/2565/large/idexlogo.png?1696503371',
  'frontier-token':
    'https://assets.coingecko.com/coins/images/12479/large/frontier_logo.png?1696512296',
  streamr:
    'https://assets.coingecko.com/coins/images/17869/large/DATA_new_symbol_3x.png?1696517392',
  'dia-data':
    'https://assets.coingecko.com/coins/images/11955/large/Token_Logo.png?1696511815',
  'clash-of-lilliput':
    'https://assets.coingecko.com/coins/images/26070/large/col.png?1696525154',
  'verus-coin':
    'https://assets.coingecko.com/coins/images/6769/large/Screenshot_33.png?1696507103',
  funfair:
    'https://assets.coingecko.com/coins/images/761/large/FUN.png?1696501914',
  tokpie:
    'https://assets.coingecko.com/coins/images/3731/large/tokpie-200x200.png?1696504401',
  'chain-2':
    'https://assets.coingecko.com/coins/images/24210/large/onyxlogo.jpg?1696523397',
  'clover-finance':
    'https://assets.coingecko.com/coins/images/15278/large/photo_2022-03-24_10-22-33.jpg?1696514930',
  ceek: 'https://assets.coingecko.com/coins/images/2581/large/ceek-smart-vr-token-logo.png?1696503385',
  ahatoken:
    'https://assets.coingecko.com/coins/images/12158/large/2022_ahatoken.jpg?1696511997',
  dione:
    'https://assets.coingecko.com/coins/images/26931/large/dione_200x200.png?1696525987',
  'thunder-token':
    'https://assets.coingecko.com/coins/images/4375/large/ThunderCore_Logo_Mark_Gradient_%283%29.png?1696504974',
  'orion-protocol':
    'https://assets.coingecko.com/coins/images/11841/large/new_logo.jpeg?1696511712',
  'kilt-protocol':
    'https://assets.coingecko.com/coins/images/20861/large/kilt.png?1696520255',
  'kyve-network':
    'https://assets.coingecko.com/coins/images/26229/large/KYVE_Logo_V2.png?1704535748',
  ecox: 'https://assets.coingecko.com/coins/images/27962/large/_ECOx.png?1696526981',
  'grok-2':
    'https://assets.coingecko.com/coins/images/32788/large/GROK.png?1707579427',
  'unifi-protocol-dao':
    'https://assets.coingecko.com/coins/images/13152/large/logo-2.png?1696512937',
  sidus:
    'https://assets.coingecko.com/coins/images/21401/large/SIDUS_coin_logo.png?1696520765',
  wifi: 'https://assets.coingecko.com/coins/images/29533/large/IMG_4643.png?1696528475',
  thorswap:
    'https://assets.coingecko.com/coins/images/19292/large/THORSwap_Logo-removebg-preview.png?1696518735',
  hackenai:
    'https://assets.coingecko.com/coins/images/11081/large/hacken-symbol-with-bg.png?1696511022',
  'iris-network':
    'https://assets.coingecko.com/coins/images/5135/large/IRIS.png?1696505654',
  vectorspace:
    'https://assets.coingecko.com/coins/images/2063/large/vectorspace-ai-logo.jpeg?1696503029',
  'axondao-governance-token':
    'https://assets.coingecko.com/coins/images/35290/large/AXGT-logo-7.png?1708076161',
  fideum:
    'https://assets.coingecko.com/coins/images/33758/large/Fideum-token.png?1702955199',
  'pstake-finance':
    'https://assets.coingecko.com/coins/images/23931/large/PSTAKE_Dark.png?1696523129',
  archway:
    'https://assets.coingecko.com/coins/images/30789/large/bxLJkEWw_400x400.jpg?1696529656',
  'uwu-lend':
    'https://assets.coingecko.com/coins/images/27408/large/uwu_logo_no-bg_1024.png?1696526449',
  'meld-2':
    'https://assets.coingecko.com/coins/images/30170/large/Twitter.jpg?1696529090',
  'stakewise-v3-oseth':
    'https://assets.coingecko.com/coins/images/33117/large/Frame_27513839.png?1700732599',
  'circuits-of-value':
    'https://assets.coingecko.com/coins/images/588/large/coval-logo.png?1696501792',
  'streamr-xdata':
    'https://assets.coingecko.com/coins/images/1115/large/streamr.png?1696502210',
  'solo-coin':
    'https://assets.coingecko.com/coins/images/10771/large/solo.png?1696510734',
  aavegotchi:
    'https://assets.coingecko.com/coins/images/12467/large/GHST.png?1696512286',
  velas:
    'https://assets.coingecko.com/coins/images/9651/large/logo_blue.png?1696509720',
  'media-licensing-token':
    'https://assets.coingecko.com/coins/images/15659/large/milc_200x200.png?1696515290',
  wanchain:
    'https://assets.coingecko.com/coins/images/3482/large/wanchain-logo.png?1696504170',
  'morpheus-network':
    'https://assets.coingecko.com/coins/images/2379/large/MRPH_CoinGecko.png?1696503245',
  'coin-capsule':
    'https://assets.coingecko.com/coins/images/15921/large/e55393fa-7b4d-40f5-9f36-9a8a6bdcb570.png?1696515534',
  aurory:
    'https://assets.coingecko.com/coins/images/19324/large/Ico_Blanc.png?1696518766',
  hxro: 'https://assets.coingecko.com/coins/images/7805/large/X_3D_Black_%2810%29.png?1696508044',
  'niza-global':
    'https://assets.coingecko.com/coins/images/32328/large/NizaCoin-logo-transaprent.png?1697451581',
  polyswarm:
    'https://assets.coingecko.com/coins/images/2843/large/ImcYCVfX_400x400.jpg?1696503602',
  altura:
    'https://assets.coingecko.com/coins/images/15127/large/logo-dark.png?1696514784',
  'helio-protocol-hay':
    'https://assets.coingecko.com/coins/images/26947/large/Coingecko_profile_lisUSD_200x200_%281%29.png?1707363097',
  thetadrop:
    'https://assets.coingecko.com/coins/images/23319/large/tdrop_pf_square_reverse.png?1696522535',
  rocketx:
    'https://assets.coingecko.com/coins/images/14728/large/avatar-correct-size-official.png?1696514397',
  sipher:
    'https://assets.coingecko.com/coins/images/21070/large/SipherToken.png?1696520453',
  groestlcoin:
    'https://assets.coingecko.com/coins/images/71/large/image001.png?1696501461',
  concordium:
    'https://assets.coingecko.com/coins/images/23547/large/Sf_cldmL_400x400.jpg?1696522754',
  'velodrome-finance':
    'https://assets.coingecko.com/coins/images/25783/large/velo.png?1696524870',
  qredo:
    'https://assets.coingecko.com/coins/images/17541/large/qrdo.png?1696517078',
  'arkadiko-protocol':
    'https://assets.coingecko.com/coins/images/21729/large/diko.png?1696521083',
  metaplex:
    'https://assets.coingecko.com/coins/images/27344/large/mplx.png?1696526391',
  hatom:
    'https://assets.coingecko.com/coins/images/31114/large/Frame_7240.png?1696529944',
  swftcoin:
    'https://assets.coingecko.com/coins/images/2346/large/SWFTCoin.jpg?1696503223',
  deapcoin:
    'https://assets.coingecko.com/coins/images/10970/large/DEAPcoin_01.png?1696510917',
  dero: 'https://assets.coingecko.com/coins/images/3522/large/dero_logo_png.png?1696504212',
  mcdex:
    'https://assets.coingecko.com/coins/images/11796/large/mux.jpg?1696511672',
  xsushi:
    'https://assets.coingecko.com/coins/images/13725/large/xsushi.png?1696513469',
  bonfida:
    'https://assets.coingecko.com/coins/images/13395/large/bonfida.png?1696513157',
  kin: 'https://assets.coingecko.com/coins/images/959/large/Kin_Logo.png?1696502073',
  astrafer:
    'https://assets.coingecko.com/coins/images/26246/large/ATSRA_Token.png?1696525331',
  'katana-inu':
    'https://assets.coingecko.com/coins/images/21872/large/Katana_Inu512.png?1696521226',
  bostrom:
    'https://assets.coingecko.com/coins/images/24617/large/boot.png?1696523789',
  'optimus-ai':
    'https://assets.coingecko.com/coins/images/29328/large/photo_2023-11-14_22-41-11.png?1700091127',
  'stride-staked-atom':
    'https://assets.coingecko.com/coins/images/26316/large/stATOM.png?1696525398',
  'iron-fish':
    'https://assets.coingecko.com/coins/images/29982/large/kxDDjheA_400x400.jpg?1696528907',
  abelian:
    'https://assets.coingecko.com/coins/images/30417/large/ABEL-LOGOS-ICONE-02.png?1696529306',
  murasaki:
    'https://assets.coingecko.com/coins/images/28570/large/mura.png?1696527558',
  'euro-coin':
    'https://assets.coingecko.com/coins/images/26045/large/euro.png?1696525125',
  mdex: 'https://assets.coingecko.com/coins/images/13775/large/mdex.png?1696513516',
  nunet:
    'https://assets.coingecko.com/coins/images/20950/large/8Zb2W2Wi_400x400.png?1696520338',
  forward:
    'https://assets.coingecko.com/coins/images/20866/large/182860872_110384464503974_4805876988713020861_n.png?1696520260',
  elysia:
    'https://assets.coingecko.com/coins/images/10887/large/CeyRVXPY_400x400.jpg?1696510840',
  kwenta:
    'https://assets.coingecko.com/coins/images/27409/large/kwenta.png?1696526450',
  'helium-iot':
    'https://assets.coingecko.com/coins/images/29880/large/Iot_Icon.png?1696528805',
  'vega-protocol':
    'https://assets.coingecko.com/coins/images/15870/large/vega.PNG?1696515485',
  'magic-internet-money':
    'https://assets.coingecko.com/coins/images/16786/large/mimlogopng.png?1696516358',
  dexcheck:
    'https://assets.coingecko.com/coins/images/26412/large/DexCheck_logo_%282%29.png?1696525488',
  'ix-swap':
    'https://assets.coingecko.com/coins/images/18069/large/ixswap.PNG?1696517577',
  'moon-tropica':
    'https://assets.coingecko.com/coins/images/28470/large/MTLOGO.png?1696527464',
  'flooring-lab-credit':
    'https://assets.coingecko.com/coins/images/32433/large/Floor_Protocol_browser_logo_mark.png?1702379738',
  mxc: 'https://assets.coingecko.com/coins/images/4604/large/mxc.png?1696505179',
  'bella-protocol':
    'https://assets.coingecko.com/coins/images/12478/large/Bella.png?1696512296',
  'jackal-protocol':
    'https://assets.coingecko.com/coins/images/28025/large/Listing_Logo_-_JKL.png?1696527040',
  'games-for-a-living':
    'https://assets.coingecko.com/coins/images/29430/large/GFAL-icon-200x200.png?1702552187',
  'wagmi-game-2':
    'https://assets.coingecko.com/coins/images/25906/large/WAGMI_DEFENSE_LOGO24_coingecko.png?1708591845',
  'dgi-game':
    'https://assets.coingecko.com/coins/images/34658/large/DGI_Game.png?1705633633',
  quick:
    'https://assets.coingecko.com/coins/images/13970/large/quick.png?1696513704',
  quickswap:
    'https://assets.coingecko.com/coins/images/25393/large/quickswap.png?1696524525',
  instadapp:
    'https://assets.coingecko.com/coins/images/14688/large/30hFM0-n_400x400.jpg?1696514361',
  'volt-inu-2':
    'https://assets.coingecko.com/coins/images/25201/large/logo200.png?1696524344',
  richquack:
    'https://assets.coingecko.com/coins/images/16356/large/57198446-0-Get-Rich-Quick-Gober.png?1696515955',
  mossland:
    'https://assets.coingecko.com/coins/images/2374/large/moc.png?1696503240',
  solama:
    'https://assets.coingecko.com/coins/images/34218/large/IMG_20240101_195943_869.jpg?1704278901',
  'ufo-gaming':
    'https://assets.coingecko.com/coins/images/16801/large/ufo.png?1696516371',
  'alpha-quark-token':
    'https://assets.coingecko.com/coins/images/12872/large/alpha_quark_logo.png?1696512660',
  'crust-network':
    'https://assets.coingecko.com/coins/images/12549/large/sAB3KVzD_400x400.jpg?1696512360',
  'sentinel-protocol':
    'https://assets.coingecko.com/coins/images/3369/large/Sentinel_Protocol.jpg?1696504069',
  starlink:
    'https://assets.coingecko.com/coins/images/16824/large/ZxJbRWJ.png?1696516393',
  'league-of-kingdoms':
    'https://assets.coingecko.com/coins/images/22572/large/loka_64pix.png?1696521891',
  'mochi-thecatcoin':
    'https://assets.coingecko.com/coins/images/33083/large/mochi200.png?1703024216',
  'whales-market':
    'https://assets.coingecko.com/coins/images/34366/large/whale_logo.jpeg?1706505535',
  'andromeda-2':
    'https://assets.coingecko.com/coins/images/33998/large/logo-square-color.png?1703600382',
  'lto-network':
    'https://assets.coingecko.com/coins/images/6068/large/lto.png?1696506473',
  sommelier:
    'https://assets.coingecko.com/coins/images/23308/large/somm_new.png?1696522525',
  selfkey:
    'https://assets.coingecko.com/coins/images/2034/large/selfkey.png?1696503004',
  'flux-token':
    'https://assets.coingecko.com/coins/images/21137/large/flx.png?1696520515',
  'aura-bal':
    'https://assets.coingecko.com/coins/images/26538/large/auraBAL.png?1696525612',
  solchat:
    'https://assets.coingecko.com/coins/images/35197/large/CHAT1.png?1709812468',
  wojak:
    'https://assets.coingecko.com/coins/images/29856/large/wojak.png?1696528782',
  'ampleforth-governance-token':
    'https://assets.coingecko.com/coins/images/14917/large/photo_2021-04-22_00.00.03.jpeg?1696514579',
  'compound-basic-attention-token':
    'https://assets.coingecko.com/coins/images/10645/large/cBAT1.JPG?1696510619',
  'rei-network':
    'https://assets.coingecko.com/coins/images/25240/large/c51_j0aB_400x400.jpg?1696524381',
  tokemak:
    'https://assets.coingecko.com/coins/images/17495/large/tokemak-avatar-200px-black.png?1696517036',
  nusd: 'https://assets.coingecko.com/coins/images/5013/large/sUSD.png?1696505546',
  neurai:
    'https://assets.coingecko.com/coins/images/30975/large/neurai-logo1.1_200px.png?1696529814',
  seth: 'https://assets.coingecko.com/coins/images/8843/large/sETH.png?1696508995',
  komodo:
    'https://assets.coingecko.com/coins/images/611/large/Icon-Light-500.png?1700052011',
  evmos:
    'https://assets.coingecko.com/coins/images/24023/large/evmos.png?1696523216',
  minswap:
    'https://assets.coingecko.com/coins/images/27823/large/download_%2811%29.png?1696526842',
  alva: 'https://assets.coingecko.com/coins/images/31720/large/alva200.png?1696530541',
  evergrowcoin:
    'https://assets.coingecko.com/coins/images/18645/large/cmc_egc_200x200_circ.png?1696518116',
  clearpool:
    'https://assets.coingecko.com/coins/images/19252/large/photo_2022-08-31_12.45.02.jpeg?1696518697',
  'ecoin-2':
    'https://assets.coingecko.com/coins/images/10849/large/IMG_4307.jpg?1696510805',
  passage:
    'https://assets.coingecko.com/coins/images/31319/large/r72xzMSQ_400x400.jpg?1696530138',
  voxies:
    'https://assets.coingecko.com/coins/images/21260/large/voxies.png?1696520632',
  'pond-coin':
    'https://assets.coingecko.com/coins/images/31215/large/pond-coin.jpeg?1696530042',
  'bnb48-club-token':
    'https://assets.coingecko.com/coins/images/13827/large/bnb48.png?1696513570',
  degate:
    'https://assets.coingecko.com/coins/images/14415/large/DG_token_brand_web_rgb_blue.png?1696514106',
  'h2o-dao':
    'https://assets.coingecko.com/coins/images/24588/large/M5-QvqZ8_400x400.jpg?1696523762',
  'feg-bsc':
    'https://assets.coingecko.com/coins/images/29644/large/feg.png?1696528581',
  'nft-worlds':
    'https://assets.coingecko.com/coins/images/22112/large/ZyBrRgfO.jpg?1696521454',
  'boson-protocol':
    'https://assets.coingecko.com/coins/images/14710/large/boson_logo.png?1696514381',
  taraxa:
    'https://assets.coingecko.com/coins/images/4372/large/CPuCDZX.jpg?1696504972',
  'concierge-io':
    'https://assets.coingecko.com/coins/images/3014/large/AVA_Logo_160x160px_Black.png?1696503750',
  polytrade:
    'https://assets.coingecko.com/coins/images/16416/large/Logo_colored_200.png?1696516012',
  openfabric:
    'https://assets.coingecko.com/coins/images/32171/large/IMG_20231005_191903_018.jpg?1696741847',
  'graphlinq-protocol':
    'https://assets.coingecko.com/coins/images/14474/large/graphlinq_logo.jpg?1696514160',
  'eth-2x-flexible-leverage-index':
    'https://assets.coingecko.com/coins/images/14392/large/ETH2x-FLI_%281%29.png?1696514083',
  keep3rv1:
    'https://assets.coingecko.com/coins/images/12966/large/kp3r_logo.jpg?1696512754',
  guacamole:
    'https://assets.coingecko.com/coins/images/30119/large/GUAC_Official_Logo.png?1696529041',
  zano: 'https://assets.coingecko.com/coins/images/8370/large/zano.png?1696508563',
  'datamall-coin':
    'https://assets.coingecko.com/coins/images/31347/large/DatamallChain.png?1696530164',
  'harambe-2':
    'https://assets.coingecko.com/coins/images/34668/large/haram_%281%29.jpg?1705655145',
  derace:
    'https://assets.coingecko.com/coins/images/17438/large/DERC_logo_coingecko.png?1696516984',
  sai: 'https://assets.coingecko.com/coins/images/1442/large/dai.png?1696502492',
  'base-god':
    'https://assets.coingecko.com/coins/images/34563/large/tybg.png?1705400778',
  thought:
    'https://assets.coingecko.com/coins/images/3071/large/IeNAK31H_400x400.jpg?1696503803',
  aqtis:
    'https://assets.coingecko.com/coins/images/29910/large/Screenshot_2023-04-14_at_17.23.46.png?1696528839',
  'forgotten-playland':
    'https://assets.coingecko.com/coins/images/35339/large/200.png?1708515043',
  'flex-usd':
    'https://assets.coingecko.com/coins/images/13323/large/flexUSD_2x.png?1696513092',
  contentos:
    'https://assets.coingecko.com/coins/images/8379/large/4036.png?1696508571',
  'e-radix':
    'https://assets.coingecko.com/coins/images/13145/large/exrd_logo.png?1696512931',
  dfuk: 'missing_large.png',
  'uxd-protocol-token':
    'https://assets.coingecko.com/coins/images/20319/large/UXP.jpg?1696519722',
  'nkyc-token':
    'https://assets.coingecko.com/coins/images/30337/large/NKYC-Logo.png?1696529238',
  'sx-network-2':
    'https://assets.coingecko.com/coins/images/34934/large/sx-ntework.jpeg?1706699134',
  octaspace:
    'https://assets.coingecko.com/coins/images/29687/large/logo-256x256.png?1696528621',
  bit2me:
    'https://assets.coingecko.com/coins/images/19848/large/b2m-circle-solid-default.png?1696519271',
  'xido-finance':
    'https://assets.coingecko.com/coins/images/16161/large/KJw4clj.png?1696515765',
  koinos:
    'https://assets.coingecko.com/coins/images/13116/large/koinos-mark-circle-250px.png?1696512903',
  'manifold-finance':
    'https://assets.coingecko.com/coins/images/15928/large/Manifold.png?1696515541',
  bean: 'https://assets.coingecko.com/coins/images/18447/large/bean-logo-coingecko.png?1696517934',
  farcana:
    'https://assets.coingecko.com/coins/images/34690/large/logo_far_black_short.png?1705853311',
  rabbitx:
    'https://assets.coingecko.com/coins/images/30048/large/RBX.png?1696528970',
  'stronghold-token':
    'https://assets.coingecko.com/coins/images/7427/large/Blue_Mark_-_White_BG.png?1696507700',
  chai: 'https://assets.coingecko.com/coins/images/10147/large/CHAI.png?1696510169',
  cellframe:
    'https://assets.coingecko.com/coins/images/14465/large/cellframe-coingecko.png?1696514152',
  tranchess:
    'https://assets.coingecko.com/coins/images/16964/large/logo_transparent_bg_200x200.png?1696516530',
  asd: 'https://assets.coingecko.com/coins/images/5003/large/bitmax.png?1696505535',
  'sappy-seals-pixl':
    'https://assets.coingecko.com/coins/images/33045/large/20220531_190522.jpg?1700450022',
  proton:
    'https://assets.coingecko.com/coins/images/10941/large/XPR.jpg?1696510891',
  taki: 'https://assets.coingecko.com/coins/images/25271/large/Social_Icon_1_200x200.png?1707905836',
  fidu: 'https://assets.coingecko.com/coins/images/25944/large/GFI-asset-icon.png?1696525023',
  'feg-token-2':
    'https://assets.coingecko.com/coins/images/29643/large/feg.png?1696528580',
  'tenet-1b000f7b-59cb-4e06-89ce-d62b32d362b9':
    'https://assets.coingecko.com/coins/images/30108/large/tenet_original.png?1696529030',
  avalaunch:
    'https://assets.coingecko.com/coins/images/15466/large/avalaunch.png?1696515112',
  thala:
    'https://assets.coingecko.com/coins/images/29697/large/thalalogo.jpg?1696528630',
  'aura-finance':
    'https://assets.coingecko.com/coins/images/25942/large/logo.png?1696525021',
  'hello-labs':
    'https://assets.coingecko.com/coins/images/27891/large/uFXN2S1N_400x400.jpeg?1696526908',
  'santos-fc-fan-token':
    'https://assets.coingecko.com/coins/images/21132/large/santos.png?1696520511',
  'wing-finance':
    'https://assets.coingecko.com/coins/images/12477/large/s_wing_icon.png?1696512295',
  'camelot-token':
    'https://assets.coingecko.com/coins/images/28416/large/vj5DIMhP_400x400.jpeg?1696527414',
  stader:
    'https://assets.coingecko.com/coins/images/20658/large/SD_Token_Logo.png?1696520060',
  'drunk-robots':
    'https://assets.coingecko.com/coins/images/24376/large/metal.png?1696523559',
  'sora-validator-token':
    'https://assets.coingecko.com/coins/images/13299/large/val-gold-256.png?1696513070',
  dimitra:
    'https://assets.coingecko.com/coins/images/18530/large/HqEiru32_400x400.jpg?1696518010',
  velo: 'https://assets.coingecko.com/coins/images/12538/large/Logo_200x_200.png?1696512350',
  'playa3ull-games-2':
    'https://assets.coingecko.com/coins/images/30695/large/App_Icon_Round.png?1696529564',
  math: 'https://assets.coingecko.com/coins/images/11335/large/2020-05-19-token-200.png?1696511257',
  'dforce-token':
    'https://assets.coingecko.com/coins/images/9709/large/xlGxxIjI_400x400.jpg?1696509776',
  amber:
    'https://assets.coingecko.com/coins/images/1041/large/amb.png?1696502148',
  propy:
    'https://assets.coingecko.com/coins/images/869/large/propy.png?1696502002',
  gameswift:
    'https://assets.coingecko.com/coins/images/30949/large/GameSwift_Token.png?1696529788',
  'gt-protocol':
    'https://assets.coingecko.com/coins/images/23118/large/A1P7aR4m_400x400.jpg?1706178875',
  'bitmart-token':
    'https://assets.coingecko.com/coins/images/5236/large/bitmart-token.png?1696505741',
  nexacoin:
    'https://assets.coingecko.com/coins/images/28729/large/200x200.png?1709182274',
  barnbridge:
    'https://assets.coingecko.com/coins/images/12811/large/barnbridge.jpg?1696512604',
  picasso:
    'https://assets.coingecko.com/coins/images/28286/large/PICA.png?1696527286',
  'the-virtua-kolect':
    'https://assets.coingecko.com/coins/images/13330/large/virtua_original.png?1696513099',
  stafi:
    'https://assets.coingecko.com/coins/images/12423/large/FIS.png?1696512244',
  'bob-token':
    'https://assets.coingecko.com/coins/images/29929/large/bob.png?1696528857',
  vicicoin:
    'https://assets.coingecko.com/coins/images/31305/large/ViciCoin_-_small.png?1696530124',
  'cronos-id':
    'https://assets.coingecko.com/coins/images/28498/large/Cronos_ID_Logo.png?1696527490',
  metacade:
    'https://assets.coingecko.com/coins/images/29764/large/Square_Profile_Photo_1080_x_1080px.png?1699396445',
  metahero:
    'https://assets.coingecko.com/coins/images/16911/large/AVATAR2.png?1696516482',
  'celo-dollar':
    'https://assets.coingecko.com/coins/images/13161/large/icon-celo-dollar-color-1000-circle-cropped.png?1696512945',
  'prime-staked-eth':
    'https://assets.coingecko.com/coins/images/34994/large/PrimeETH_Token_Logo.png?1706951612',
  propchain:
    'https://assets.coingecko.com/coins/images/30451/large/prop_%281%29.png?1702322253',
  'tether-eurt':
    'https://assets.coingecko.com/coins/images/17385/large/Tether_new.png?1696516934',
  'limewire-token':
    'https://assets.coingecko.com/coins/images/30356/large/LimeWire_Logo_Icon_200x200_%281%29.png?1696529256',
  'creo-engine':
    'https://assets.coingecko.com/coins/images/25419/large/17000.png?1696524549',
  ethos:
    'https://assets.coingecko.com/coins/images/794/large/Voyager-vgx.png?1696501945',
  catgirl:
    'https://assets.coingecko.com/coins/images/16472/large/catgirl-200x200.png?1696516067',
  'paris-saint-germain-fan-token':
    'https://assets.coingecko.com/coins/images/11620/large/psg.png?1696511513',
  gamium:
    'https://assets.coingecko.com/coins/images/22749/large/14304.png?1696522053',
  tokocrypto:
    'https://assets.coingecko.com/coins/images/14577/large/tko-logo.png?1696514258',
  'advertise-coin':
    'https://assets.coingecko.com/coins/images/14344/large/advertisecoin200x200.png?1696514031',
  gogopool:
    'https://assets.coingecko.com/coins/images/30267/large/GGP_logo_square.png?1696529174',
  'football-at-alphaverse':
    'https://assets.coingecko.com/coins/images/31974/large/fav.png?1704731064',
  connext:
    'https://assets.coingecko.com/coins/images/31293/large/connext.png?1696530113',
  gho: 'https://assets.coingecko.com/coins/images/30663/large/ghoaave.jpeg?1696529533',
  nuls: 'https://assets.coingecko.com/coins/images/1053/large/2021_NULS_ICON_Tra-01.png?1696502158',
  'stride-staked-osmo':
    'https://assets.coingecko.com/coins/images/28698/large/stOSMO_800.png?1696527680',
  ramp: 'https://assets.coingecko.com/coins/images/12837/large/RAMP-Logo-v2-1000pxsq.png?1696512628',
  'vara-network':
    'https://assets.coingecko.com/coins/images/31458/large/vara.jpeg?1696530272',
  airswap:
    'https://assets.coingecko.com/coins/images/1019/large/Airswap.png?1696502130',
  hathor:
    'https://assets.coingecko.com/coins/images/12718/large/hathor_logo.png?1696512519',
  'eusd-new':
    'https://assets.coingecko.com/coins/images/31603/large/eusd.png?1696530419',
  'strips-finance':
    'https://assets.coingecko.com/coins/images/18327/large/Logo-Strips-200-x-200px---without-words.png?1696517818',
  'socean-staked-sol':
    'https://assets.coingecko.com/coins/images/18468/large/scnSOL.png?1705660582',
  klever:
    'https://assets.coingecko.com/coins/images/12240/large/hIonpevN_400x400.jpg?1696512072',
  'step-app-fitfi':
    'https://assets.coingecko.com/coins/images/25015/large/200x200.png?1701432003',
  talken:
    'https://assets.coingecko.com/coins/images/18146/large/4NNLx3BF_400x400.jpg?1696517648',
  'chihuahua-token':
    'https://assets.coingecko.com/coins/images/22485/large/logo_transparent_notext.png?1696521808',
  railgun:
    'https://assets.coingecko.com/coins/images/16840/large/railgun.jpeg?1696516407',
  tectonic:
    'https://assets.coingecko.com/coins/images/21982/large/TONIC_logo.png?1696521330',
  'xen-crypto':
    'https://assets.coingecko.com/coins/images/27713/large/Xen.jpeg?1696526739',
  'maiar-dex':
    'https://assets.coingecko.com/coins/images/20657/large/MEX-icon.png?1696520059',
  omnicat:
    'https://assets.coingecko.com/coins/images/33917/large/2023-12-21_21.39.10.jpg?1703321588',
  'unlend-finance':
    'https://assets.coingecko.com/coins/images/12819/large/UniLend_Finance_logo_PNG.png?1696512611',
  stfx: 'https://assets.coingecko.com/coins/images/28631/large/stfx.png?1696527615',
  parsiq:
    'https://assets.coingecko.com/coins/images/11973/large/DsNgK0O.png?1696511831',
  pluton:
    'https://assets.coingecko.com/coins/images/1241/large/pluton.png?1696502316',
  enjinstarter:
    'https://assets.coingecko.com/coins/images/18732/large/l-R1nYA0_400x400.jpg?1696518198',
  'harvest-finance':
    'https://assets.coingecko.com/coins/images/12304/large/FARM_200x200.png?1696512134',
  cratos:
    'https://assets.coingecko.com/coins/images/17322/large/cratos.png?1696516876',
  ponke:
    'https://assets.coingecko.com/coins/images/33929/large/ponke.png?1703415326',
  'red-pulse':
    'https://assets.coingecko.com/coins/images/1074/large/phoenix-logo.png?1696502176',
  meveth:
    'https://assets.coingecko.com/coins/images/32153/large/MEV_logo_2.png?1696598728',
  'token-dforce-usd':
    'https://assets.coingecko.com/coins/images/17422/large/usx_32.png?1696516969',
  pivx: 'https://assets.coingecko.com/coins/images/548/large/PIVX-Shield.png?1696501766',
  'miracle-play':
    'https://assets.coingecko.com/coins/images/32653/large/MPT.png?1698895300',
  sentinel:
    'https://assets.coingecko.com/coins/images/14879/large/YMEMrc-V_400x400.jpg?1701124143',
  'nuco-cloud':
    'https://assets.coingecko.com/coins/images/8932/large/nucloud_logo.png?1696509080',
  'frax-price-index-share':
    'https://assets.coingecko.com/coins/images/24944/large/FPIS_icon.png?1696524099',
  'de-fi':
    'https://assets.coingecko.com/coins/images/34369/large/defi_logo.png?1704905360',
  snowbank:
    'https://assets.coingecko.com/coins/images/19947/large/sb.png?1696519364',
  temple:
    'https://assets.coingecko.com/coins/images/20040/large/LPK15ZOW_400x400.jpg?1696519459',
  somesing:
    'https://assets.coingecko.com/coins/images/10089/large/ico_ss_4x.png?1696510118',
  'vidt-dao':
    'https://assets.coingecko.com/coins/images/27552/large/VIDTDAO_logo.png?1696526588',
  'alpaca-finance':
    'https://assets.coingecko.com/coins/images/14165/large/Logo200.png?1696513884',
  'pepe-2-0':
    'https://assets.coingecko.com/coins/images/30853/large/PEPE_2.0.png?1707684909',
  dxdao:
    'https://assets.coingecko.com/coins/images/11148/large/dxdao.png?1696511083',
  district0x:
    'https://assets.coingecko.com/coins/images/849/large/district0x.png?1696501985',
  deepfakeai:
    'https://assets.coingecko.com/coins/images/30633/large/Safeimagekit-resized-img_%286%29.png?1696529506',
  lords:
    'https://assets.coingecko.com/coins/images/22171/large/Frame_1.png?1696521515',
  vite: 'https://assets.coingecko.com/coins/images/4513/large/VITE_new_logo_200px.png?1709175957',
  'tg-casino':
    'https://assets.coingecko.com/coins/images/34473/large/TGC_Logo_200x200.png?1704998035',
  'swarm-bzz':
    'https://assets.coingecko.com/coins/images/16509/large/Circle_Orange_onWhite.png?1696516071',
  adex: 'https://assets.coingecko.com/coins/images/847/large/adex.jpeg?1696501984',
  melon:
    'https://assets.coingecko.com/coins/images/605/large/Enzyme_Icon_Secondary.png?1696501803',
  kardiachain:
    'https://assets.coingecko.com/coins/images/7942/large/kai.png?1696508172',
  volumint:
    'https://assets.coingecko.com/coins/images/33745/large/volumint_200x200px_clearbg.png?1702924153',
  'apollox-2':
    'https://assets.coingecko.com/coins/images/21972/large/apx.png?1696521320',
  'rowan-coin':
    'https://assets.coingecko.com/coins/images/11812/large/rsz_60398173_433122580805477_3770982655982567424_n_1.png?1696511685',
  'decentral-games':
    'https://assets.coingecko.com/coins/images/21173/large/Decentral_Games_Logo-1.png?1696520549',
  xsgd: 'https://assets.coingecko.com/coins/images/12832/large/StraitsX_Singapore_Dollar_%28XSGD%29_Token_Logo.png?1696512623',
  vaultcraft:
    'https://assets.coingecko.com/coins/images/33237/large/VCX_Token_200x200.png?1701147660',
  magpie:
    'https://assets.coingecko.com/coins/images/27972/large/MagpieLogo.png?1696526991',
  'crypto-asset-governance-alliance':
    'https://assets.coingecko.com/coins/images/32846/large/200px_caga_transparent.png?1707469892',
  lingose:
    'https://assets.coingecko.com/coins/images/27271/large/ling.png?1696526323',
  'defi-kingdoms':
    'https://assets.coingecko.com/coins/images/18570/large/jewel_token_x2.png?1702076846',
  'kava-lend':
    'https://assets.coingecko.com/coins/images/13008/large/HARD_coin_256.png?1696512797',
  'fc-barcelona-fan-token':
    'https://assets.coingecko.com/coins/images/11693/large/Barca-10.png?1696511582',
  'any-inu':
    'https://assets.coingecko.com/coins/images/34126/large/anyinulogo200.png?1704174269',
  'index-cooperative':
    'https://assets.coingecko.com/coins/images/12729/large/index.png?1696512528',
  'matrix-ai-network':
    'https://assets.coingecko.com/coins/images/2698/large/Matrix_logo.png?1696503482',
  hsuite:
    'https://assets.coingecko.com/coins/images/28593/large/hbar.jpeg?1696527580',
  'beefy-finance':
    'https://assets.coingecko.com/coins/images/12704/large/bifi.png?1698202580',
  'carbon-browser':
    'https://assets.coingecko.com/coins/images/28905/large/csix.png?1696527881',
  'juno-network':
    'https://assets.coingecko.com/coins/images/19249/large/Juno_Logo_%28Salmon%29_%282%29.png?1696518694',
  'karate-combat':
    'https://assets.coingecko.com/coins/images/30384/large/karate.jpg?1696529274',
  'cetus-protocol':
    'https://assets.coingecko.com/coins/images/30256/large/cetus.png?1696529165',
  alkimi:
    'https://assets.coingecko.com/coins/images/17979/large/ADS.png?1706546465',
  'octopus-network':
    'https://assets.coingecko.com/coins/images/18025/large/octopus_network.png?1696517541',
  'step-finance':
    'https://assets.coingecko.com/coins/images/14988/large/step.png?1696514652',
  'pirate-chain':
    'https://assets.coingecko.com/coins/images/6905/large/Pirate_Chain.png?1696507223',
  'polaris-share':
    'https://assets.coingecko.com/coins/images/13817/large/tHQrxdYQ_400x400.png?1696513563',
  'the-big-five':
    'https://assets.coingecko.com/coins/images/27429/large/photo_2022-08-01_16-49-53.jpg?1696526470',
  mintlayer:
    'https://assets.coingecko.com/coins/images/29454/large/mintlayer-icon-coingecko200x200.png?1696528401',
  botto:
    'https://assets.coingecko.com/coins/images/18892/large/bottos_logo.jpg?1696518350',
  only1:
    'https://assets.coingecko.com/coins/images/17501/large/like-token.png?1696517041',
  troy: 'https://assets.coingecko.com/coins/images/10057/large/troy.png?1696510087',
  connex:
    'https://assets.coingecko.com/coins/images/31779/large/conx-cg.png?1696530597',
  kleros:
    'https://assets.coingecko.com/coins/images/3833/large/kleros.png?1696504500',
  dogechain:
    'https://assets.coingecko.com/coins/images/26828/large/dogechain.jpeg?1696525887',
  'fio-protocol':
    'https://assets.coingecko.com/coins/images/11821/large/fio_light_favicon_square.png?1697267276',
  'jesus-coin':
    'https://assets.coingecko.com/coins/images/30036/large/JESUS_COIN_LOGO.png?1696528959',
  'defipulse-index':
    'https://assets.coingecko.com/coins/images/12465/large/defi_pulse_index_set.png?1696512284',
  imgnai:
    'https://assets.coingecko.com/coins/images/28666/large/imgnai-200x200.png?1698476572',
  petals:
    'https://assets.coingecko.com/coins/images/26154/large/pts.png?1696525242',
  sperax:
    'https://assets.coingecko.com/coins/images/12232/large/sperax_logo.jpg?1696512065',
  counterparty:
    'https://assets.coingecko.com/coins/images/9/large/counterparty.png?1696501413',
  babybonk:
    'https://assets.coingecko.com/coins/images/33808/large/babybonk-200.png?1702993306',
  beoble:
    'https://assets.coingecko.com/coins/images/35011/large/beoble_200px.png?1707102471',
  'symbiosis-finance':
    'https://assets.coingecko.com/coins/images/20805/large/SymbiosisFinance_logo-150x150.jpeg?1696520198',
  'pintu-token':
    'https://assets.coingecko.com/coins/images/20281/large/image_1_8dd79a68aa.png?1696519686',
  kompete:
    'https://assets.coingecko.com/coins/images/24298/large/KOMPETE_LOGO.?1696523480',
  'jpeg-d':
    'https://assets.coingecko.com/coins/images/24025/large/et_43CNi_400x400.jpg?1696523217',
  'newscrypto-coin':
    'https://assets.coingecko.com/coins/images/9805/large/Tu1_NI3s_%281%29.png?1696509862',
  phantasma:
    'https://assets.coingecko.com/coins/images/4130/large/phantasma.png?1696504758',
  holdstation:
    'https://assets.coingecko.com/coins/images/32726/large/HOLD.png?1699018663',
  'shiba-predator':
    'https://assets.coingecko.com/coins/images/24430/large/l1KzMcL.png?1696523611',
  'data-lake':
    'https://assets.coingecko.com/coins/images/29279/large/VWlCfLlX_400x400.jpeg?1696528232',
  'subquery-network':
    'https://assets.coingecko.com/coins/images/23359/large/photo_2021-07-14_11-31-12.jpg?1696522574',
  'alpine-f1-team-fan-token':
    'https://assets.coingecko.com/coins/images/23717/large/18112.png?1696522917',
  researchcoin:
    'https://assets.coingecko.com/coins/images/28146/large/RH_Logo_200x200.png?1696527152',
  'get-token':
    'https://assets.coingecko.com/coins/images/1927/large/GET_Protocol.png?1696502916',
  weway:
    'https://assets.coingecko.com/coins/images/22418/large/wwy.png?1696521760',
  kizuna:
    'https://assets.coingecko.com/coins/images/32113/large/IMG_9968.png?1696585475',
  nest: 'https://assets.coingecko.com/coins/images/11284/large/52954052.png?1696511207',
  'compound-uniswap':
    'https://assets.coingecko.com/coins/images/12696/large/compound-uni.png?1696512499',
  artyfact:
    'https://assets.coingecko.com/coins/images/33879/large/arty.png?1703146847',
  'quantum-resistant-ledger':
    'https://assets.coingecko.com/coins/images/700/large/yellow-black.512x512.png?1696501888',
  ellipsis:
    'https://assets.coingecko.com/coins/images/14498/large/ellipsis-light.png?1696514184',
  havah:
    'https://assets.coingecko.com/coins/images/29156/large/hvh.png?1696528115',
  honk: 'https://assets.coingecko.com/coins/images/34532/large/200_goose.png?1705323721',
  ovr: 'https://assets.coingecko.com/coins/images/13429/large/LOGO-OVER-ICON-200X200PX.png?1699396496',
  'vector-reserve':
    'https://assets.coingecko.com/coins/images/34876/large/vec200.png?1709644054',
  'iskra-token':
    'https://assets.coingecko.com/coins/images/27428/large/ISKRA_logo.png?1696526469',
  'castello-coin':
    'https://assets.coingecko.com/coins/images/25216/large/19705.png?1696524359',
  scallop:
    'https://assets.coingecko.com/coins/images/19059/large/scallop.PNG?1696518509',
  hegic:
    'https://assets.coingecko.com/coins/images/12454/large/new.png?1696512274',
  'kira-network':
    'https://assets.coingecko.com/coins/images/13232/large/KEX-200x200.png?1705676884',
  blockv:
    'https://assets.coingecko.com/coins/images/1266/large/blockv.png?1696502339',
  zcoin:
    'https://assets.coingecko.com/coins/images/479/large/firocoingecko.png?1696501734',
  'precipitate-ai':
    'https://assets.coingecko.com/coins/images/32405/large/bluedrop_200-removebg-preview.png?1698056874',
  'kishu-inu':
    'https://assets.coingecko.com/coins/images/14890/large/uVLzCoP.png?1696514553',
  'cryptex-finance':
    'https://assets.coingecko.com/coins/images/14932/large/glossy_icon_-_C200px.png?1696514592',
  chronobank:
    'https://assets.coingecko.com/coins/images/604/large/time-32x32.png?1696501802',
  'vlaunch-2':
    'https://assets.coingecko.com/coins/images/34991/large/VPAD.png?1707061585',
  'poolz-finance-2':
    'https://assets.coingecko.com/coins/images/29625/large/logomark-black_%282%29.png?1696528561',
  'indigo-dao-governance-token':
    'https://assets.coingecko.com/coins/images/28303/large/IndigoTokenCMC.png?1696527302',
  'wagmi-2':
    'https://assets.coingecko.com/coins/images/31887/large/wagmi_token_logo.png?1696530698',
  'og-fan-token':
    'https://assets.coingecko.com/coins/images/11663/large/og.jpg?1696511554',
  'safemoon-2':
    'https://assets.coingecko.com/coins/images/21863/large/photo_2021-12-22_14.43.36.jpeg?1696521217',
  solanium:
    'https://assets.coingecko.com/coins/images/15816/large/logo_cg.png?1696515435',
  dexalot:
    'https://assets.coingecko.com/coins/images/24188/large/logo_200x200.png?1696523376',
  'real-smurf-cat':
    'https://assets.coingecko.com/coins/images/31751/large/SMURFCAT.png?1708079642',
  rmrk: 'https://assets.coingecko.com/coins/images/18656/large/download_%281%29_%281%29.png?1696518126',
  'yfii-finance':
    'https://assets.coingecko.com/coins/images/11902/large/YFII-logo.78631676.png?1696511768',
  'bitmex-token':
    'https://assets.coingecko.com/coins/images/21831/large/bitmex-token.jpeg?1696521187',
  rarible:
    'https://assets.coingecko.com/coins/images/11845/large/Rari.png?1696511716',
  'sideshift-token':
    'https://assets.coingecko.com/coins/images/15719/large/sideshift-icon_3x.png?1696515346',
  banana:
    'https://assets.coingecko.com/coins/images/17521/large/banana-token-cg.png?1696517059',
  'burger-swap':
    'https://assets.coingecko.com/coins/images/12563/large/burger.png?1696512372',
  'roko-network':
    'https://assets.coingecko.com/coins/images/29427/large/1.618_200.jpg?1696528376',
  affyn:
    'https://assets.coingecko.com/coins/images/23275/large/fyn.png?1696522495',
  leopold:
    'https://assets.coingecko.com/coins/images/34175/large/imresizer-1704428645492.jpg?1704504097',
  'cryptogpt-token':
    'https://assets.coingecko.com/coins/images/29223/large/Favicon_200x200px.png?1696528181',
  'avax-has-no-chill':
    'https://assets.coingecko.com/coins/images/34002/large/IMG_4040.jpeg?1703602967',
  'stader-bnbx':
    'https://assets.coingecko.com/coins/images/26842/large/BNBx_Logo.png?1696525902',
  'manchester-city-fan-token':
    'https://assets.coingecko.com/coins/images/15799/large/mJgwTHzCVVCJlqo1tF0NWP57igOYSXr5k1Vqvomd.png?1696515421',
  'kenshi-2':
    'https://assets.coingecko.com/coins/images/30759/large/kenshi.jpg?1696529628',
  'acet-token':
    'https://assets.coingecko.com/coins/images/18205/large/ACET-LOGO.png?1696517703',
  hairdao:
    'https://assets.coingecko.com/coins/images/29620/large/LinkedIn_Logo.jpg?1696528556',
  pinksale:
    'https://assets.coingecko.com/coins/images/17377/large/4cC4Fgs.png?1696516927',
  serum:
    'https://assets.coingecko.com/coins/images/11970/large/serum-logo.png?1696511829',
  'bifrost-native-coin':
    'https://assets.coingecko.com/coins/images/19259/large/bifrost.png?1696518703',
  onbuff:
    'https://assets.coingecko.com/coins/images/12252/large/d4suDHSzEZjDXc0uxFGPZXfDFp0L1tfoEusBx03zB1bvMLLbxa7Yq5naXAOutkirIlLXacFRRebX_hF2Ez69_fIPUfr2LuN0Z_UrXTLYds4aT95C6eHGXsZnezMHKAaOmjLpKto0xPTiYkXExvEvXrqL7O_J1wecb4eJsgwCoVprMLpm89BdKO9IyMmpNsfbW7JJFMiHgL8vq9fPhaeEi.jpg?1696512083',
  gifto:
    'https://assets.coingecko.com/coins/images/1359/large/Logo-Sign-Small.png?1696502418',
  'loaf-cat':
    'https://assets.coingecko.com/coins/images/34106/large/Fi19x9G-_400x400.png?1703976276',
  zer0zer0:
    'https://assets.coingecko.com/coins/images/27742/large/200x200.png?1696526765',
  avinoc:
    'https://assets.coingecko.com/coins/images/4659/large/qX7fh69Q_400x400-1.jpg?1696505226',
  'libra-incentix':
    'https://assets.coingecko.com/coins/images/31996/large/lixx.jpg?1696530797',
  stakewise:
    'https://assets.coingecko.com/coins/images/15044/large/stakewise200.png?1696514703',
  mettalex:
    'https://assets.coingecko.com/coins/images/12730/large/nrEqFTEW_400x400.jpg?1696512529',
  'bitcoin-diamond':
    'https://assets.coingecko.com/coins/images/1254/large/bitcoin-diamond.png?1696502328',
  fulcrom:
    'https://assets.coingecko.com/coins/images/29684/large/FUL_Token_%281%29.png?1696528618',
  'token-pocket':
    'https://assets.coingecko.com/coins/images/7603/large/pocket.jpg?1696507861',
  'lazio-fan-token':
    'https://assets.coingecko.com/coins/images/19263/large/B4Lla6V6_400x400.png?1696518707',
  aeternity:
    'https://assets.coingecko.com/coins/images/1091/large/aeternity.png?1696502190',
  'onomy-protocol':
    'https://assets.coingecko.com/coins/images/23328/large/200x200_dark_logo.png?1696522544',
  strikecoin:
    'https://assets.coingecko.com/coins/images/15839/large/StrikeX-Icon-200px.png?1696515456',
  aviator:
    'https://assets.coingecko.com/coins/images/31024/large/Aviator-Icon_200x200.png?1696529860',
  't-mac-dao':
    'https://assets.coingecko.com/coins/images/28117/large/tmg.png?1696527125',
  'fuse-network-token':
    'https://assets.coingecko.com/coins/images/10347/large/fuse.png?1696510348',
  trustswap:
    'https://assets.coingecko.com/coins/images/11795/large/Untitled_design-removebg-preview.png?1696511671',
  meld: 'https://assets.coingecko.com/coins/images/23380/large/Twitter.jpg?1696522595',
  'shade-protocol':
    'https://assets.coingecko.com/coins/images/23804/large/NEAKadeZ_400x400.jpg?1696523002',
  'verified-usd-foundation-usdv':
    'https://assets.coingecko.com/coins/images/32948/large/usdv_%281%29.png?1699933314',
  dtravel:
    'https://assets.coingecko.com/coins/images/20911/large/trvl.jpeg?1696520301',
  'blockchain-bets':
    'https://assets.coingecko.com/coins/images/28694/large/200x200.jpg?1696527676',
  'taboo-token':
    'https://assets.coingecko.com/coins/images/6111/large/taboo.PNG?1696506510',
  kryll:
    'https://assets.coingecko.com/coins/images/2807/large/krl.png?1696503571',
  'silo-finance':
    'https://assets.coingecko.com/coins/images/21454/large/y0iYKZOv_400x400.png?1696520816',
  karura:
    'https://assets.coingecko.com/coins/images/17172/large/karura.jpeg?1696516731',
  'vita-inu':
    'https://assets.coingecko.com/coins/images/20594/large/vita-inu-head-wallet-icon-transparent.png?1696520000',
  kimbo:
    'https://assets.coingecko.com/coins/images/33793/large/kimbo.jpg?1702989206',
  adshares:
    'https://assets.coingecko.com/coins/images/868/large/rnO9DyJ.png?1696502001',
  'flex-coin':
    'https://assets.coingecko.com/coins/images/9108/large/coinflex_logo.png?1696509233',
  'ichi-farm':
    'https://assets.coingecko.com/coins/images/13119/large/ICHI_%28Round%29.jpg?1696512907',
  aquarius:
    'https://assets.coingecko.com/coins/images/20026/large/aqua-logo.png?1696519446',
  mute: 'https://assets.coingecko.com/coins/images/14331/large/MUTE.png?1696514019',
  'inverse-finance':
    'https://assets.coingecko.com/coins/images/14205/large/inverse_finance.jpg?1696513922',
  'mars-protocol-a7fcbcfb-fd61-4017-92f0-7ee9f9cc6da3':
    'https://assets.coingecko.com/coins/images/28896/large/mars.png?1696527872',
  blocksquare:
    'https://assets.coingecko.com/coins/images/23924/large/XpkkqPVR_400x400.jpg?1696523122',
  'winr-protocol':
    'https://assets.coingecko.com/coins/images/29340/large/WINR.png?1696528290',
  suiswap:
    'https://assets.coingecko.com/coins/images/30688/large/suiswap-200.png?1696529557',
  'bad-idea-ai':
    'https://assets.coingecko.com/coins/images/30871/large/Bad_idea.jpeg?1696529718',
  mimatic:
    'https://assets.coingecko.com/coins/images/15264/large/mimatic-red.png?1696514916',
  usd: 'https://assets.coingecko.com/coins/images/25757/large/USD__logo.png?1696524843',
  'niko-2':
    'https://assets.coingecko.com/coins/images/33834/large/resized200.png?1703107281',
  'octo-gaming':
    'https://assets.coingecko.com/coins/images/29154/large/icon-otk-big-filled.png?1696528113',
  'magic-square':
    'https://assets.coingecko.com/coins/images/26377/large/bafkreictuxcsw472vuroqwv7maumzsa4pfhrdw6tglpme7zfdkce62niau_%281%29.jpg?1696525455',
  aipad:
    'https://assets.coingecko.com/coins/images/28894/large/JZadeHu.jpeg?1696527870',
  'poollotto-finance':
    'https://assets.coingecko.com/coins/images/21425/large/polotto.png?1696520788',
  hypergpt:
    'https://assets.coingecko.com/coins/images/30428/large/favicon.png?1696529317',
  'saros-finance':
    'https://assets.coingecko.com/coins/images/34594/large/saros-token-logo.png?1705476813',
  hacash:
    'https://assets.coingecko.com/coins/images/14765/large/hac_200.png?1701797420',
  colony:
    'https://assets.coingecko.com/coins/images/21358/large/colony.PNG?1696520723',
  saito:
    'https://assets.coingecko.com/coins/images/14750/large/SAITO.png?1696514419',
  qash: 'https://assets.coingecko.com/coins/images/1220/large/qash.jpeg?1696502299',
  'pups-ordinals':
    'https://assets.coingecko.com/coins/images/34390/large/btc-brc20-pups.png?1704782162',
  orange:
    'https://assets.coingecko.com/coins/images/34935/large/fgvhaJjX_400x400.jpg?1706708564',
  mixmarvel:
    'https://assets.coingecko.com/coins/images/8222/large/8878caf93b1e3b6cfb3b414bda3b5250.png?1696508428',
  unibright:
    'https://assets.coingecko.com/coins/images/2707/large/UnibrightLogo_colorful_500x500_preview.png?1696503489',
  'hoge-finance':
    'https://assets.coingecko.com/coins/images/14360/large/hoge.jpg?1696514046',
  pip: 'https://assets.coingecko.com/coins/images/22384/large/qE35Vvc4_400x400.jpg?1696521728',
  'd3d-social':
    'https://assets.coingecko.com/coins/images/28921/large/LogoD3D.png?1696527896',
  'honeyland-honey':
    'https://assets.coingecko.com/coins/images/29256/large/hxd-200x200.png?1696528210',
  rigoblock:
    'https://assets.coingecko.com/coins/images/1532/large/Symbol-RigoblockRGB.png?1696502572',
  'wall-street-memes':
    'https://assets.coingecko.com/coins/images/31975/large/Wall_Street_Memes_Logo_resize.png?1696530778',
  monai:
    'https://assets.coingecko.com/coins/images/35661/large/2024-03-02_02.02.09.png?1709453630',
  humanode:
    'https://assets.coingecko.com/coins/images/29645/large/humanode.jpg?1696528581',
  'zkswap-finance':
    'https://assets.coingecko.com/coins/images/31633/large/zf.png?1696530449',
  'crypto-gladiator-shards':
    'https://assets.coingecko.com/coins/images/18291/large/Scalable.png?1696517783',
  'mind-language':
    'https://assets.coingecko.com/coins/images/33540/large/mind-logo-black-resized.png?1702378297',
  bytom:
    'https://assets.coingecko.com/coins/images/1087/large/2qNyrhUxEmnGCKi.png?1696502187',
  'lithium-finance':
    'https://assets.coingecko.com/coins/images/17278/large/Lithium_Logo-03200x200.png?1696516832',
  'platypus-usd':
    'https://assets.coingecko.com/coins/images/28963/large/USP_4168x4168.png?1696527935',
  'project-with':
    'https://assets.coingecko.com/coins/images/9182/large/2_0C4zaAE66q6I_k4uBmgqkw.png?1696509302',
  bficoin:
    'https://assets.coingecko.com/coins/images/14884/large/Asset_1.png?1696514548',
  vaulttech:
    'https://assets.coingecko.com/coins/images/32578/large/IMG_6957.jpeg?1698558686',
  'hera-finance':
    'https://assets.coingecko.com/coins/images/24751/large/logo-icon-200x.png?1696523913',
  'nodle-network':
    'https://assets.coingecko.com/coins/images/27019/large/nodle.png?1696526071',
  shiden:
    'https://assets.coingecko.com/coins/images/18027/large/tFOtjrr3_400x400.png?1696517543',
  'bzx-protocol':
    'https://assets.coingecko.com/coins/images/11811/large/bzrx.png?1696511684',
  gamee:
    'https://assets.coingecko.com/coins/images/14716/large/gmee-200x200.png?1696514386',
  'punk-2':
    'https://assets.coingecko.com/coins/images/31049/large/F4FDA24D-1B29-4CBB-8346-854D1BFFE75A.png?1696529883',
  'dream-machine-token':
    'https://assets.coingecko.com/coins/images/30505/large/dmt.png?1696529391',
  everdome:
    'https://assets.coingecko.com/coins/images/23267/large/Ix-ms0fq_400x400.jpg?1696522487',
  'revest-finance':
    'https://assets.coingecko.com/coins/images/18622/large/Qma94n6waADECpde1ukBBS8iNiECcdVcxjfgubnWPE9ZT7.png?1696518094',
  'rejuve-ai':
    'https://assets.coingecko.com/coins/images/29366/large/2023_Rejuve_Logo_-_Square_-_Teal.jpg?1696528314',
  decubate:
    'https://assets.coingecko.com/coins/images/16909/large/Logo-Decubate_200x200.png?1696516480',
  thales:
    'https://assets.coingecko.com/coins/images/18388/large/CLVZJN_C_400x400.png?1696517879',
  veraone:
    'https://assets.coingecko.com/coins/images/11112/large/wsBaVF.png?1696511051',
  geodnet:
    'https://assets.coingecko.com/coins/images/31608/large/Circular_White.png?1696530424',
  sylo: 'https://assets.coingecko.com/coins/images/6430/large/SYLO.svg?1696506795',
  kryptonite:
    'https://assets.coingecko.com/coins/images/31252/large/Kryptonite_PFP-03.png?1696530076',
  renbtc:
    'https://assets.coingecko.com/coins/images/11370/large/Bitcoin.jpg?1696511287',
  sophiaverse:
    'https://assets.coingecko.com/coins/images/30050/large/Icon_200x200.png?1696528972',
  flokifork:
    'https://assets.coingecko.com/coins/images/35048/large/floki-inu-floki-logo200x200.png?1707206165',
  viberate:
    'https://assets.coingecko.com/coins/images/983/large/Viberate.png?1696502096',
  xdefi:
    'https://assets.coingecko.com/coins/images/19524/large/FilledLogo.png?1696518958',
  decimated:
    'https://assets.coingecko.com/coins/images/8271/large/dio_logo_coloured_transparent.png?1696508474',
  'ta-da':
    'https://assets.coingecko.com/coins/images/35180/large/img-linkedin-companyavatar_copie.jpg?1707796022',
  amo: 'https://assets.coingecko.com/coins/images/4009/large/amo-logomark_black.png?1696504648',
  'stader-sftmx':
    'https://assets.coingecko.com/coins/images/26586/large/sftmx.png?1709705714',
  ageur:
    'https://assets.coingecko.com/coins/images/19479/large/agEUR.png?1696518915',
  'ferrum-network':
    'https://assets.coingecko.com/coins/images/8251/large/FRM.png?1696508455',
  spookyswap:
    'https://assets.coingecko.com/coins/images/15223/large/logo_200x200.png?1696514878',
  'ai-network':
    'https://assets.coingecko.com/coins/images/13211/large/AI_Network_Logo_200x200.png?1696512991',
  wigoswap:
    'https://assets.coingecko.com/coins/images/23603/large/wigo.png?1696522810',
  'land-of-conquest-slg':
    'https://assets.coingecko.com/coins/images/26436/large/SLG_LOGO18.jpg?1706730326',
  moby: 'https://assets.coingecko.com/coins/images/35146/large/photo_2024-02-13_09-43-04.jpg?1707846594',
  umee: 'https://assets.coingecko.com/coins/images/20635/large/yArLkbL.png?1696520039',
  mooxmoo:
    'https://assets.coingecko.com/coins/images/32493/large/MOOX.jpg?1698293551',
  angola:
    'https://assets.coingecko.com/coins/images/27547/large/8SGgovDI_400x400.png?1696526584',
  'stake-dao':
    'https://assets.coingecko.com/coins/images/13724/large/stakedao_logo.jpg?1696513468',
  beam: 'https://assets.coingecko.com/coins/images/7339/large/BEAM.png?1696507623',
  'areon-network':
    'https://assets.coingecko.com/coins/images/28764/large/photo_2023-01-04_22-48-03.jpg?1696527743',
  'ethereum-meta':
    'https://assets.coingecko.com/coins/images/6586/large/ethereum-meta.png?1696506937',
  propbase:
    'https://assets.coingecko.com/coins/images/32932/large/PROP_BASE_%286%29.png?1699870054',
  'concentrated-voting-power':
    'https://assets.coingecko.com/coins/images/12266/large/Powerpool.jpg?1696512097',
  lambda:
    'https://assets.coingecko.com/coins/images/4703/large/lambda_200.png?1696505268',
  hydra:
    'https://assets.coingecko.com/coins/images/13631/large/photo_2020-11-27_18-25-06.jpg?1696513379',
  'deepbrain-chain':
    'https://assets.coingecko.com/coins/images/2057/large/DeepBrainChain.png?1696503024',
  'solcasino-token':
    'https://assets.coingecko.com/coins/images/30228/large/logo_%282%29.png?1696529138',
  snailbrook:
    'https://assets.coingecko.com/coins/images/29922/large/snail_200x200.png?1696528851',
  'moonwell-artemis':
    'https://assets.coingecko.com/coins/images/26133/large/WELL.png?1696525221',
  'web3games-com-token':
    'https://assets.coingecko.com/coins/images/34449/large/_WGT_token.png?1704899852',
  'swarm-markets':
    'https://assets.coingecko.com/coins/images/17488/large/swarm-SMT-token-symbol_200x200.png?1696517029',
  joystream:
    'https://assets.coingecko.com/coins/images/24785/large/joy.png?1696523945',
  'drep-new':
    'https://assets.coingecko.com/coins/images/14578/large/KotgsCgS_400x400.jpg?1696514258',
  analos:
    'https://assets.coingecko.com/coins/images/33855/large/image_4_%286%29.png?1703125199',
  holoride:
    'https://assets.coingecko.com/coins/images/21626/large/RIDE_Token_Symbol_MASTER.png?1696520986',
  geojam:
    'https://assets.coingecko.com/coins/images/24648/large/200px_Transparent_Bubble_Token_Icon.png?1696523818',
  'mango-markets':
    'https://assets.coingecko.com/coins/images/14773/large/token-mango.png?1696514442',
  'epik-prime':
    'https://assets.coingecko.com/coins/images/17907/large/EPIK_Prime_LOGO.jpg?1696517427',
  'orbofi-ai':
    'https://assets.coingecko.com/coins/images/30216/large/new_V_test2.png?1696529127',
  'rangers-protocol-gas':
    'https://assets.coingecko.com/coins/images/18791/large/tO8MlqiM_400x400.png?1633421196',
  hubble:
    'https://assets.coingecko.com/coins/images/22070/large/hubble.PNG?1696521414',
  'kyber-network':
    'https://assets.coingecko.com/coins/images/947/large/logo-kncl.png?1696502063',
  'prometheum-prodigy':
    'https://assets.coingecko.com/coins/images/32522/large/IMG_1277.jpeg?1708596900',
  neoxa:
    'https://assets.coingecko.com/coins/images/26417/large/Logo-Round_%281%29.png?1696525493',
  sbtc: 'https://assets.coingecko.com/coins/images/8838/large/sBTC.png?1696508990',
  banano:
    'https://assets.coingecko.com/coins/images/6226/large/banano-transparent.png?1696506611',
  altair:
    'https://assets.coingecko.com/coins/images/23548/large/altair.jpeg?1696522755',
  'interest-compounding-eth-index':
    'https://assets.coingecko.com/coins/images/24483/large/icETH-token-logo.png?1696523661',
  'cakepie-xyz':
    'https://assets.coingecko.com/coins/images/34267/large/1_%281%29.png?1704389397',
  'wise-token11':
    'https://assets.coingecko.com/coins/images/13552/large/Wise.jpg.jpg?1696513309',
  'snfts-seedify-nft-space':
    'https://assets.coingecko.com/coins/images/27131/large/seedify.jpg?1696526183',
  'force-protocol':
    'https://assets.coingecko.com/coins/images/8242/large/for.png?1606195375',
  digitalbits:
    'https://assets.coingecko.com/coins/images/8089/large/XDB_CHAIN_LOGO.jpeg?1702723430',
  handshake:
    'https://assets.coingecko.com/coins/images/10562/large/circle-handshakeLogo.png?1696510545',
  prosper:
    'https://assets.coingecko.com/coins/images/13668/large/heD6cg22l3sF5VgPh4G1xC6lnKEWXJif-jbaqUpv8CDP6jbWaqn9UjBdkXWNrw1CewaQOxb8zXRdNeNJWWiUDjfsEl_d7E3bPLg4cFoilQF5TGKHfWyJlnpm3UYc9ytvRvOjxOevMuiu8-lusnNoOcwgsJpMkYWHqe322GAxLt0_30kFMVAcjEDUrOlkK6hUYi0m9P433mvNlOm.jpg?1696513418',
  zusd: 'https://assets.coingecko.com/coins/images/14192/large/icon_zusd_200_200.png?1696513910',
  polkafoundry:
    'https://assets.coingecko.com/coins/images/14422/large/red_kite.png?1696514112',
  bitrock:
    'https://assets.coingecko.com/coins/images/30987/large/20230713_155626.png?1696529826',
  'cult-dao':
    'https://assets.coingecko.com/coins/images/23331/large/quxZPrbC_400x400.jpg?1696522547',
  unmarshal:
    'https://assets.coingecko.com/coins/images/14554/large/img_circle_256x256.png?1696514237',
  'ethereum-push-notification-service':
    'https://assets.coingecko.com/coins/images/14769/large/aiOxYOJI_400x400.jpeg?1696514438',
  oxygen:
    'https://assets.coingecko.com/coins/images/13509/large/8DjBZ79V_400x400.jpg?1696513271',
  perion:
    'https://assets.coingecko.com/coins/images/23302/large/PERC.png?1696522520',
  'globiance-exchange':
    'https://assets.coingecko.com/coins/images/24859/large/gbex.png?1696524019',
  suku: 'https://assets.coingecko.com/coins/images/11969/large/suku-200.png?1696511828',
  swash:
    'https://assets.coingecko.com/coins/images/18774/large/Swash_CMC_light.png?1696878896',
  'non-playable-coin':
    'https://assets.coingecko.com/coins/images/31193/large/NPC_200x200.png?1696530021',
  kasta:
    'https://assets.coingecko.com/coins/images/22293/large/Kasta.png?1696521639',
  'electronic-usd':
    'https://assets.coingecko.com/coins/images/28445/large/0xa0d69e286b938e21cbf7e51d71f6a4c8918f482f.png?1696527441',
  blockasset:
    'https://assets.coingecko.com/coins/images/21332/large/Blockasset-Logo-Symbol.png?1696520699',
  pnetwork:
    'https://assets.coingecko.com/coins/images/11659/large/pNetwork.png?1696511550',
  'shina-inu':
    'https://assets.coingecko.com/coins/images/25208/large/coingecko-shina-purple-bg.png?1696524352',
  'reality-metaverse':
    'https://assets.coingecko.com/coins/images/29806/large/rltm.png?1696528735',
  'gamer-arena':
    'https://assets.coingecko.com/coins/images/28151/large/200x200.png?1696527156',
  atpay:
    'https://assets.coingecko.com/coins/images/27254/large/atpay.png?1696526303',
  whiteheart:
    'https://assets.coingecko.com/coins/images/13484/large/whiteheart.png?1696513245',
  'muse-2':
    'https://assets.coingecko.com/coins/images/13230/large/muse_logo.png?1696513008',
  switcheo:
    'https://assets.coingecko.com/coins/images/3645/large/SWTH_Symbol_Origin.png?1696504327',
  dragonchain:
    'https://assets.coingecko.com/coins/images/1289/large/dragonchain.png?1696502360',
  'liza-2':
    'https://assets.coingecko.com/coins/images/32841/large/Liza.png?1699589053',
  source:
    'https://assets.coingecko.com/coins/images/32553/large/Source.png?1698494535',
  'mirror-protocol':
    'https://assets.coingecko.com/coins/images/13295/large/mirror_logo_transparent.png?1696513067',
  'bitrue-token':
    'https://assets.coingecko.com/coins/images/8873/large/Bittrue_logo.png?1696509025',
  'doge-eat-doge':
    'https://assets.coingecko.com/coins/images/26878/large/omnom.jpg?1696525937',
  'baby-grok':
    'https://assets.coingecko.com/coins/images/32972/large/photo_2023-11-10_15-50-54.jpg?1700064075',
  'juventus-fan-token':
    'https://assets.coingecko.com/coins/images/10060/large/Juve-10.png?1696510090',
  'vecrv-dao-yvault':
    'https://assets.coingecko.com/coins/images/13065/large/yearn_veCRV.png?1696512854',
  domi: 'https://assets.coingecko.com/coins/images/21633/large/Transparent_Circle_Logo_2.png?1696520993',
  energi:
    'https://assets.coingecko.com/coins/images/5795/large/3218.png?1696506239',
  gains:
    'https://assets.coingecko.com/coins/images/14681/large/200x200.png?1696514354',
  'cosplay-token-2':
    'https://assets.coingecko.com/coins/images/21294/large/brave_ZxsjzUc8xn.png?1696520664',
  'white-whale':
    'https://assets.coingecko.com/coins/images/21628/large/whale.png?1696520988',
  'nimiq-2':
    'https://assets.coingecko.com/coins/images/5119/large/nimiq.png?1696505640',
  astropepex:
    'https://assets.coingecko.com/coins/images/31839/large/cglogo.png?1699223398',
  'vector-eth':
    'https://assets.coingecko.com/coins/images/35085/large/vETH200.png?1709644096',
  fsn: 'https://assets.coingecko.com/coins/images/2515/large/Fusion_200x200.png?1696503329',
  plxyer:
    'https://assets.coingecko.com/coins/images/31346/large/200X200.png?1696530163',
  premia:
    'https://assets.coingecko.com/coins/images/13962/large/apple-touch-icon.png?1696513698',
  jumptoken:
    'https://assets.coingecko.com/coins/images/22603/large/200x200.png?1696521919',
  'prisma-governance-token':
    'https://assets.coingecko.com/coins/images/31520/large/PRISMA_200.png?1696530330',
  catecoin:
    'https://assets.coingecko.com/coins/images/15364/large/logo.png?1696515013',
  'fimarkcoin-com':
    'https://assets.coingecko.com/coins/images/33132/large/fimarkcoin.png?1702316882',
  'arsenal-fan-token':
    'https://assets.coingecko.com/coins/images/17661/large/HEKLrDI.png?1696517192',
  hourglass:
    'https://assets.coingecko.com/coins/images/27516/large/Hourglass-Logo.png?1696526555',
  carbify:
    'https://assets.coingecko.com/coins/images/29892/large/Carbify_logo.png?1696528816',
  spacen:
    'https://assets.coingecko.com/coins/images/27576/large/sn.png?1696526609',
  'oho-blockchain':
    'https://assets.coingecko.com/coins/images/27854/large/OHO_200_x_200.png?1696526873',
  'yield-app':
    'https://assets.coingecko.com/coins/images/13365/large/Google_Play_Store_Icon.png?1696513130',
  'nada-protocol-token':
    'https://assets.coingecko.com/coins/images/27517/large/NADA_200.png?1696526556',
  findora:
    'https://assets.coingecko.com/coins/images/14725/large/Vector.jpeg?1708064617',
  monkeyball:
    'https://assets.coingecko.com/coins/images/20841/large/monkeyball.png?1696520233',
  'solve-care':
    'https://assets.coingecko.com/coins/images/1768/large/Solve.Token_logo_200_200_wiyhout_BG.png?1696502776',
  maidsafecoin:
    'https://assets.coingecko.com/coins/images/80/large/maidsafecoin.png?1696501470',
  spartadex:
    'https://assets.coingecko.com/coins/images/30836/large/SpartaDex_200x200.jpg?1696529694',
  'somnium-space-cubes':
    'https://assets.coingecko.com/coins/images/10687/large/CUBE_icon.png?1696510656',
  storx:
    'https://assets.coingecko.com/coins/images/16922/large/StorX_Logo_white_300x300-01.png?1696516493',
  leox: 'https://assets.coingecko.com/coins/images/29980/large/LEOX-LOGO-BLACK-2.jpg?1696528905',
  'gala-music':
    'https://assets.coingecko.com/coins/images/33472/large/gmusic.jpeg?1701947141',
  penpie:
    'https://assets.coingecko.com/coins/images/30760/large/PNP_Token.png?1696529629',
  octavia:
    'https://assets.coingecko.com/coins/images/35108/large/logo_%281%29.png?1707382639',
  'stader-nearx':
    'https://assets.coingecko.com/coins/images/27787/large/Nearx.png?1696526808',
  'lybra-finance':
    'https://assets.coingecko.com/coins/images/29958/large/New_LBR_V2.png?1696528884',
  presearch:
    'https://assets.coingecko.com/coins/images/1299/large/presearch.png?1696502369',
  genopets:
    'https://assets.coingecko.com/coins/images/20360/large/gene-token.png?1696519768',
  wombat:
    'https://assets.coingecko.com/coins/images/26430/large/Project_Page_Icon.png?1696525504',
  lube: 'https://assets.coingecko.com/coins/images/33070/large/Lube2-icon-200x200.png?1708581050',
  reboot:
    'https://assets.coingecko.com/coins/images/31228/large/gg_cyan_black_square.png?1703749951',
  'ac-milan-fan-token':
    'https://assets.coingecko.com/coins/images/13940/large/ACM-10.png?1696513678',
  paragonsdao:
    'https://assets.coingecko.com/coins/images/22642/large/PDT_LOGO_200.jpg?1696521956',
  'iron-bank-euro':
    'https://assets.coingecko.com/coins/images/17285/large/Iron_Bank_Euro.png?1696516839',
  'dego-finance':
    'https://assets.coingecko.com/coins/images/12503/large/c185FKx.png?1696512318',
  mixmob:
    'https://assets.coingecko.com/coins/images/34708/large/MXM_Token.png?1705893936',
  hapi: 'https://assets.coingecko.com/coins/images/14298/large/Hapi_logo_square_%281%29.png?1696513995',
  witnet:
    'https://assets.coingecko.com/coins/images/11109/large/wit.png?1696511049',
  bscpad:
    'https://assets.coingecko.com/coins/images/14135/large/bscpad_logo.jpg?1696513855',
  'gamma-strategies':
    'https://assets.coingecko.com/coins/images/21975/large/gamma-token-200.png?1696521323',
  pkt: 'https://assets.coingecko.com/coins/images/15293/large/PKT_Icon_smaller_new-01.png?1696514944',
  babb: 'https://assets.coingecko.com/coins/images/2168/large/babb.png?1696503128',
  'atlas-navi':
    'https://assets.coingecko.com/coins/images/28389/large/token_icon_-_logo_ATLAS_NAVI_200x200_transparent.png?1696527388',
  ashswap:
    'https://assets.coingecko.com/coins/images/27913/large/ash-logo.png?1696526934',
  'as-roma-fan-token':
    'https://assets.coingecko.com/coins/images/11688/large/Roma-10.png?1696511577',
  bitcicoin:
    'https://assets.coingecko.com/coins/images/13816/large/output-onlinepngtools.png?1696513562',
  mantadao:
    'https://assets.coingecko.com/coins/images/30352/large/MNTA_Token_CG.png?1696529252',
  'foam-protocol':
    'https://assets.coingecko.com/coins/images/3345/large/K51lJQc.png?1696504049',
  algebra:
    'https://assets.coingecko.com/coins/images/19580/large/13211.png?1696519011',
  moon: 'https://assets.coingecko.com/coins/images/11222/large/Moons.png?1696511153',
  polydoge:
    'https://assets.coingecko.com/coins/images/15146/large/p1kSco1h_400x400.jpg?1696514802',
  'robonomics-network':
    'https://assets.coingecko.com/coins/images/7024/large/Robonomics-Network-logo.png?1696507330',
  revv: 'https://assets.coingecko.com/coins/images/12373/large/REVV_TOKEN_Refined_2021_%281%29.png?1696512197',
  messier:
    'https://assets.coingecko.com/coins/images/25957/large/MESSIERlogonew_%281%29.png?1696525036',
  multichain:
    'https://assets.coingecko.com/coins/images/22087/large/1_Wyot-SDGZuxbjdkaOeT2-A.png?1696521430',
  itheum:
    'https://assets.coingecko.com/coins/images/25361/large/itheum.png?1696524494',
  'robo-inu-finance':
    'https://assets.coingecko.com/coins/images/20821/large/O68Gs5SE_400x400.jpg?1696520214',
  'dust-protocol':
    'https://assets.coingecko.com/coins/images/24289/large/6388d49d-1f00-448d-92bc-f2db1441bbce.?1696523472',
  cumrocket:
    'https://assets.coingecko.com/coins/images/15088/large/cr.png?1696514747',
  'galatasaray-fan-token':
    'https://assets.coingecko.com/coins/images/11585/large/Galatasaray-10.png?1696511482',
  etherisc:
    'https://assets.coingecko.com/coins/images/4586/large/dip.png?1696505164',
  quiztok:
    'https://assets.coingecko.com/coins/images/8208/large/QTCON.png?1696508415',
  unisocks:
    'https://assets.coingecko.com/coins/images/10717/large/qFrcoiM.png?1696510685',
  'safe-deal':
    'https://assets.coingecko.com/coins/images/12661/large/Eb2xbVb.png?1696512467',
  'meme-ai-coin':
    'https://assets.coingecko.com/coins/images/34356/large/MEMEAI.png?1704706407',
  'fei-usd':
    'https://assets.coingecko.com/coins/images/14570/large/ZqsF51Re_400x400.png?1696514251',
  radiant:
    'https://assets.coingecko.com/coins/images/27382/large/Radiant_new_circle.png?1696526425',
  'atletico-madrid':
    'https://assets.coingecko.com/coins/images/11689/large/Atletico-10.png?1696511578',
  lossless:
    'https://assets.coingecko.com/coins/images/15917/large/Group_57.png?1696515531',
  calaxy:
    'https://assets.coingecko.com/coins/images/25638/large/CLXY_logo_sm.png?1696524772',
  'zenon-2':
    'https://assets.coingecko.com/coins/images/30753/large/zenon.jpg?1696529622',
  arkitech:
    'https://assets.coingecko.com/coins/images/33426/large/ARKITECH.jpg?1701792569',
  husd: 'https://assets.coingecko.com/coins/images/9567/large/HUSD.jpg?1696509647',
  splinterlands:
    'https://assets.coingecko.com/coins/images/17332/large/splinter.PNG?1696516884',
  'dua-token':
    'https://assets.coingecko.com/coins/images/27976/large/Screenshot_2023-06-13_at_11.58.02_AM.png?1696526994',
  'diamond-launch':
    'https://assets.coingecko.com/coins/images/27323/large/dlc.png?1696526371',
  azit: 'https://assets.coingecko.com/coins/images/24515/large/ofbC3qtQ_400x400.jpg?1696523694',
  'hector-dao':
    'https://assets.coingecko.com/coins/images/19832/large/logo-final.png?1696519255',
  'ben-2':
    'https://assets.coingecko.com/coins/images/30175/large/BEN_COIN.png?1696529094',
  kiboshib:
    'https://assets.coingecko.com/coins/images/29335/large/foto_no_exif_%2811%29%282%29_%281%29.png?1696528285',
  openocean:
    'https://assets.coingecko.com/coins/images/17014/large/ooe_log.png?1696516578',
  'observer-coin':
    'https://assets.coingecko.com/coins/images/7474/large/obsr.png?1696507745',
  nolus:
    'https://assets.coingecko.com/coins/images/30786/large/nolus_logo_element.png?1696529653',
  'cream-2':
    'https://assets.coingecko.com/coins/images/11976/large/Cream.png?1696511834',
  cargox:
    'https://assets.coingecko.com/coins/images/2580/large/cargox.png?1696503384',
  'ix-token':
    'https://assets.coingecko.com/coins/images/20927/large/IXT_LOGO_PNG_RGB_200X.png?1696520316',
  efinity:
    'https://assets.coingecko.com/coins/images/16558/large/efi-200px_%281%29.png?1696516119',
  ethichub:
    'https://assets.coingecko.com/coins/images/3031/large/ETHIX_icon_256x256-256.png?1696503766',
  pibble:
    'https://assets.coingecko.com/coins/images/2972/large/pibble.jpg?1696503713',
  'solareum-d260e488-50a0-4048-ace4-1b82f9822903':
    'https://assets.coingecko.com/coins/images/30072/large/green_lrg_transparent.png?1696528993',
  wicrypt:
    'https://assets.coingecko.com/coins/images/21223/large/wicrypt.PNG?1696520597',
  'gari-network':
    'https://assets.coingecko.com/coins/images/22615/large/gari.png?1696521931',
  buying:
    'https://assets.coingecko.com/coins/images/5290/large/buying_200x200.png?1696505788',
  netvrk:
    'https://assets.coingecko.com/coins/images/15721/large/netvrk_icon.png?1696515348',
  ridotto:
    'https://assets.coingecko.com/coins/images/18671/large/200x200_%2832%29.png?1696518141',
  'ai-power-grid':
    'https://assets.coingecko.com/coins/images/33878/large/hl-13242694702.png?1704288699',
  minted:
    'https://assets.coingecko.com/coins/images/26893/large/MTD_Token_%282%29.png?1696525951',
  'rai-finance':
    'https://assets.coingecko.com/coins/images/14686/large/sofi.png?1696514359',
  gyen: 'https://assets.coingecko.com/coins/images/14191/large/icon_gyen_200_200.png?1696513909',
  'gecko-meme':
    'https://assets.coingecko.com/coins/images/33712/large/1gecko-coin-logo-compressed.png?1702867288',
  'luna-inu':
    'https://assets.coingecko.com/coins/images/25623/large/output-onlinepngtools.png?1696524757',
  'aura-network':
    'https://assets.coingecko.com/coins/images/25768/large/LOGO-AURA-WHITE.png?1696524855',
  comsats:
    'https://assets.coingecko.com/coins/images/33082/large/logo11.png?1700578238',
  'bozo-hybrid':
    'https://assets.coingecko.com/coins/images/34555/large/bozo.png?1705370111',
  impt: 'https://assets.coingecko.com/coins/images/28486/large/IMPT_logo.png?1696527478',
  dopex:
    'https://assets.coingecko.com/coins/images/16652/large/DPX_%281%29.png?1696516213',
  'litlab-games':
    'https://assets.coingecko.com/coins/images/29930/large/_LITT_token_logo.png?1696528858',
  plearn:
    'https://assets.coingecko.com/coins/images/24723/large/plearn200x200.png?1696523887',
  axel: 'https://assets.coingecko.com/coins/images/9765/large/axel-logo-250px.png?1696509825',
  'apollo-2':
    'https://assets.coingecko.com/coins/images/34792/large/apollo-png-256.png?1706031403',
  chirpley:
    'https://assets.coingecko.com/coins/images/27243/large/Chirpley-Logo_200x200.png?1696526293',
  'rain-coin':
    'https://assets.coingecko.com/coins/images/34032/large/rain_coin_logo.png?1703676333',
  'brn-metaverse':
    'https://assets.coingecko.com/coins/images/25363/large/brn.png?1696524496',
  'crypto-carbon-energy-2':
    'https://assets.coingecko.com/coins/images/29824/large/CYCE.jpg?1696528752',
  grin: 'https://assets.coingecko.com/coins/images/7340/large/grin.png?1696507624',
  'catcoin-cash':
    'https://assets.coingecko.com/coins/images/25279/large/cat5.png?1696524419',
  wasder:
    'https://assets.coingecko.com/coins/images/15374/large/wasderBoxedLogoWhite-200x200.png?1696515022',
  'mangoman-intelligent':
    'https://assets.coingecko.com/coins/images/26687/large/Mr._B.png?1696525761',
  'wrapped-ampleforth':
    'https://assets.coingecko.com/coins/images/20825/large/photo_2021-11-25_02-05-11.jpg?1696520218',
  squidgrow:
    'https://assets.coingecko.com/coins/images/26573/large/Squidgrow-Logo.png?1696525645',
  'inter-milan-fan-token':
    'https://assets.coingecko.com/coins/images/18288/large/chz.png?1696517781',
  kleva:
    'https://assets.coingecko.com/coins/images/26546/large/Kleva_400x400.png?1696525619',
  'roaland-core':
    'https://assets.coingecko.com/coins/images/29153/large/roa.png?1696528112',
  thena:
    'https://assets.coingecko.com/coins/images/28864/large/Symbol-Color200x200.png?1706810126',
  nvirworld:
    'https://assets.coingecko.com/coins/images/21359/large/Nvir_symbol.png?1696520724',
  masq: 'https://assets.coingecko.com/coins/images/13699/large/masq.png?1696513446',
  'redfox-labs-2':
    'https://assets.coingecko.com/coins/images/12956/large/rfox.png?1696512744',
  morra:
    'https://assets.coingecko.com/coins/images/33180/large/MORRA.png?1705245739',
  'blockchain-brawlers':
    'https://assets.coingecko.com/coins/images/24701/large/fuDdvI8Y_400x400.png?1696523867',
  gameai:
    'https://assets.coingecko.com/coins/images/31669/large/IMG_20230827_004646_377.jpg?1696530485',
  dextf:
    'https://assets.coingecko.com/coins/images/12634/large/0qgT0aMu_400x400.jpg?1696512442',
  'iq-protocol':
    'https://assets.coingecko.com/coins/images/23274/large/-zCkqMuQ.jpeg?1700084588',
  ooki: 'https://assets.coingecko.com/coins/images/21719/large/Ooki_Token.png?1696521074',
  'vesta-finance':
    'https://assets.coingecko.com/coins/images/23306/large/vesta-finance.png?1696522523',
  playzap:
    'https://assets.coingecko.com/coins/images/24727/large/200X200-111.png?1696523890',
  'omax-token':
    'https://assets.coingecko.com/coins/images/19853/large/omxlogo.png?1696519276',
  'exosama-network':
    'https://assets.coingecko.com/coins/images/28308/large/Small.png?1696527312',
  'flooring-protocol-microboredapeyachtclub':
    'https://assets.coingecko.com/coins/images/32690/large/bayctoken.png?1698974036',
  velhalla:
    'https://assets.coingecko.com/coins/images/20421/large/velhalla_DP.png?1696519829',
  'oni-token':
    'https://assets.coingecko.com/coins/images/9405/large/Oni_Round.png?1696509502',
  'lunr-token':
    'https://assets.coingecko.com/coins/images/19256/large/LunarCrush-Earn-Logo.png?1708183703',
  torum:
    'https://assets.coingecko.com/coins/images/18393/large/torum-transparent-cmc.png?1696517884',
  'husky-avax':
    'https://assets.coingecko.com/coins/images/17812/large/husky.png?1696517332',
  'bazed-games':
    'https://assets.coingecko.com/coins/images/31195/large/IMG_1849.jpeg?1696530023',
  'kapital-dao':
    'https://assets.coingecko.com/coins/images/27682/large/KAP_Logo.png?1696526710',
  nftx: 'https://assets.coingecko.com/coins/images/13574/large/NFTX_%28Real%29.jpg?1696513327',
  'tree-capital':
    'https://assets.coingecko.com/coins/images/33727/large/circle_green.png?1709894067',
  goldcoin:
    'https://assets.coingecko.com/coins/images/49/large/newlogo_trans_sm.png?1696501445',
  'warped-games':
    'https://assets.coingecko.com/coins/images/33307/large/Warped-ICON-COLOR-ORANGE.png?1709639013',
  'defi-land':
    'https://assets.coingecko.com/coins/images/18910/large/defilend.png?1696518368',
  'polka-city':
    'https://assets.coingecko.com/coins/images/14066/large/vykih1Nq_400x400.png?1696513790',
  openanx:
    'https://assets.coingecko.com/coins/images/853/large/OAXlogo.png?1696501987',
  'vela-token':
    'https://assets.coingecko.com/coins/images/28739/large/VELA_logo_-_no_background.png?1696527719',
  ferro:
    'https://assets.coingecko.com/coins/images/26111/large/FER_Token.png?1696525201',
  terracoin:
    'https://assets.coingecko.com/coins/images/31/large/Terracoin.png?1696501434',
  'pika-protocol':
    'https://assets.coingecko.com/coins/images/30279/large/Pika_protocol.png?1696529185',
  'adappter-token':
    'https://assets.coingecko.com/coins/images/14203/large/logo_on.png?1696513920',
  'gameswap-org':
    'https://assets.coingecko.com/coins/images/13026/large/gameswap.jpg?1696512814',
  'unicrypt-2':
    'https://assets.coingecko.com/coins/images/12871/large/uncx.png?1696512659',
  'rupiah-token':
    'https://assets.coingecko.com/coins/images/9441/large/57421944_1371636006308255_3647136573922738176_n.jpg?1696509533',
  senate:
    'https://assets.coingecko.com/coins/images/21272/large/siIBOmcs.png?1696520643',
  'origin-dollar':
    'https://assets.coingecko.com/coins/images/12589/large/ousd-logo-200x200.png?1696512399',
  'yusd-stablecoin':
    'https://assets.coingecko.com/coins/images/25024/large/1_oJ0F2Zf6CuAhLP0zOboo6w.png?1696524176',
  marsdao:
    'https://assets.coingecko.com/coins/images/24126/large/mdao.png?1696523317',
  edge: 'https://assets.coingecko.com/coins/images/1848/large/EDGE.png?1696502846',
  onedex:
    'https://assets.coingecko.com/coins/images/29579/large/OneDex_new_Logo.png?1704776259',
  radium:
    'https://assets.coingecko.com/coins/images/338/large/download_%2818%29.png?1696501666',
  hmx: 'https://assets.coingecko.com/coins/images/31206/large/HMXlogo_CG.png?1696530033',
  'shiba-saga':
    'https://assets.coingecko.com/coins/images/31437/large/51nmYxm3_400x400.jpg?1696530252',
  'battle-world':
    'https://assets.coingecko.com/coins/images/25799/large/battleworld_logo_200x200.png?1696524885',
  'steam-exchange':
    'https://assets.coingecko.com/coins/images/16914/large/steamx.png?1696516485',
  'ref-finance':
    'https://assets.coingecko.com/coins/images/18279/large/ref.png?1696517772',
  polkaswap:
    'https://assets.coingecko.com/coins/images/15475/large/pswap-token-logomark-ticker-icon-200px-transparent-optimized.png?1696515120',
  'decentral-games-governance':
    'https://assets.coingecko.com/coins/images/21176/large/xDG_Logo.png?1696520552',
  wirex:
    'https://assets.coingecko.com/coins/images/8835/large/Wirex.jpg?1696508988',
  bitshares:
    'https://assets.coingecko.com/coins/images/95/large/bts.png?1696501477',
  'six-network':
    'https://assets.coingecko.com/coins/images/3769/large/SIX_Network_Token.png?1699426809',
  'blocx-2':
    'https://assets.coingecko.com/coins/images/31237/large/BLOCX.png?1703581121',
  'bepro-network':
    'https://assets.coingecko.com/coins/images/10251/large/logo.png?1696510261',
  'smart-valor':
    'https://assets.coingecko.com/coins/images/7231/large/1._SMART_VALOR__Logo_NEW.png?1696507527',
  'veloce-vext':
    'https://assets.coingecko.com/coins/images/31214/large/VEXT_Logo.jpg?1696530041',
  'aegis-ai':
    'https://assets.coingecko.com/coins/images/33169/large/UXDa3TDq_400x400.jpg?1700909114',
  everid:
    'https://assets.coingecko.com/coins/images/5209/large/Everest.jpg?1696505719',
  paribus:
    'https://assets.coingecko.com/coins/images/18410/large/paribus.PNG?1696517900',
  'equilibria-finance':
    'https://assets.coingecko.com/coins/images/30645/large/QLLK8pmR_400x400.jpg?1696529516',
  'btu-protocol':
    'https://assets.coingecko.com/coins/images/3697/large/logo-btu-white-background_%281%29.png?1707407754',
  gamezone:
    'https://assets.coingecko.com/coins/images/18697/large/Th98fbg__400x400.jpg?1696518165',
  'apf-coin':
    'https://assets.coingecko.com/coins/images/30990/large/photo_2023-10-28_09-48-25.jpg?1698518912',
  everrise:
    'https://assets.coingecko.com/coins/images/16367/large/Logo_EverRise_Icon_logo.png?1696515966',
  purefi:
    'https://assets.coingecko.com/coins/images/17341/large/purefi.PNG?1696516893',
  enosys:
    'https://assets.coingecko.com/coins/images/32098/large/HLN_-_200x200.png?1698173363',
  pawswap:
    'https://assets.coingecko.com/coins/images/28946/large/PawLogo.png?1699394612',
  'hypr-network':
    'https://assets.coingecko.com/coins/images/33071/large/655412078d33fa9fee8e3a1b_hypr_logo_200.png?1700598490',
  'eve-ai':
    'https://assets.coingecko.com/coins/images/29830/large/200-X-200.png?1696528758',
  'aladdin-dao':
    'https://assets.coingecko.com/coins/images/18277/large/78200839.png?1696517771',
  ion: 'https://assets.coingecko.com/coins/images/16731/large/ion-osmosis.png?1696516304',
  dappradar:
    'https://assets.coingecko.com/coins/images/20894/large/radar.png?1696520286',
  'tensorplex-staked-tao':
    'https://assets.coingecko.com/coins/images/35330/large/stTAO_Logo.png?1708268881',
  mainnetz:
    'https://assets.coingecko.com/coins/images/33947/large/zcM8MEO5_400x400.png?1703537595',
  eggdog:
    'https://assets.coingecko.com/coins/images/33754/large/Egg_%28Custom%29.png?1702946771',
  'extra-finance':
    'https://assets.coingecko.com/coins/images/30973/large/Ex_logo-white-blue_ring_288x.png?1696529812',
  canxium:
    'https://assets.coingecko.com/coins/images/31709/large/canxium.png?1696530531',
  'cryowar-token':
    'https://assets.coingecko.com/coins/images/20227/large/CWAR_round_200_200.png?1696519636',
  'kitty-inu':
    'https://assets.coingecko.com/coins/images/19385/large/KITTY.png?1696518825',
  'shyft-network-2':
    'https://assets.coingecko.com/coins/images/14534/large/TOKEN-Gradient.png?1696514218',
  gorilla:
    'https://assets.coingecko.com/coins/images/33006/large/IMG_20231110_124057_942.jpg?1700123171',
  goosefx:
    'https://assets.coingecko.com/coins/images/19793/large/0Kjm9f4.png?1696519215',
  'iguverse-igu':
    'https://assets.coingecko.com/coins/images/29112/large/IGU_500x500.png?1696528074',
  refund:
    'https://assets.coingecko.com/coins/images/30501/large/Avatar_%282%29.png?1696529387',
  arianee:
    'https://assets.coingecko.com/coins/images/5054/large/Aria_Logo_256.png?1696505581',
  'notional-finance':
    'https://assets.coingecko.com/coins/images/20282/large/NOTE-340x340.png?1696519687',
  rhinofi:
    'https://assets.coingecko.com/coins/images/16414/large/rhinologo.png?1697736807',
  bosagora:
    'https://assets.coingecko.com/coins/images/9202/large/Picture1.png?1696509320',
  kryptomon:
    'https://assets.coingecko.com/coins/images/17886/large/kryptomon.png?1696517407',
  augur:
    'https://assets.coingecko.com/coins/images/309/large/REP.png?1696501648',
  zorro:
    'https://assets.coingecko.com/coins/images/34381/large/ZORRO_TP.png?1704777748',
  'permission-coin':
    'https://assets.coingecko.com/coins/images/12521/large/rjQjTU3c_400x400.jpg?1696512335',
  elumia:
    'https://assets.coingecko.com/coins/images/24433/large/me4oOqTM_400x400.png?1696523614',
  'send-token':
    'https://assets.coingecko.com/coins/images/30847/large/logo_send_new_africa.png?1709638658',
  divi: 'https://assets.coingecko.com/coins/images/1273/large/red_logomark.png?1696502345',
  chappyz:
    'https://assets.coingecko.com/coins/images/32728/large/Chappyz200x200.png?1699217057',
  'effect-network':
    'https://assets.coingecko.com/coins/images/3012/large/logomark_effect-network.png?1696503748',
  'celo-euro':
    'https://assets.coingecko.com/coins/images/16756/large/CEUR.png?1696516329',
  'hanu-yokia':
    'https://assets.coingecko.com/coins/images/17161/large/Goji_Hanu_Logo_200x200.png?1696516720',
  'market-making-pro':
    'https://assets.coingecko.com/coins/images/20386/large/MMPRO_LOGO_W.png?1696519796',
  peercoin:
    'https://assets.coingecko.com/coins/images/4/large/peercoin-icon-green-transparent_6x.png?1696501402',
  'klaycity-orb':
    'https://assets.coingecko.com/coins/images/24332/large/OrbCity_enlarged.jpg?1696523517',
  panther:
    'https://assets.coingecko.com/coins/images/18611/large/panther.jpg?1696518084',
  qlink:
    'https://assets.coingecko.com/coins/images/2053/large/2321.png?1696503020',
  hydranet:
    'https://assets.coingecko.com/coins/images/25177/large/HDXdarkblueInv.png?1696524322',
  inscribe:
    'https://assets.coingecko.com/coins/images/34960/large/nwb4N3Gx_400x400.jpg?1706788569',
  'paint-swap':
    'https://assets.coingecko.com/coins/images/18579/large/ps-cmc-200x200.png?1707862125',
  'd-drops':
    'https://assets.coingecko.com/coins/images/26611/large/ddrops_%281%29.png?1696525685',
  'dhedge-dao':
    'https://assets.coingecko.com/coins/images/12508/large/dht.png?1696512323',
  'angle-protocol':
    'https://assets.coingecko.com/coins/images/19060/large/ANGLE_Token-light.png?1696518509',
  '0chain':
    'https://assets.coingecko.com/coins/images/4934/large/200x200_transparent.png?1696505474',
  ispolink:
    'https://assets.coingecko.com/coins/images/15283/large/isolink.PNG?1696514934',
  'metaverse-index':
    'https://assets.coingecko.com/coins/images/14684/large/MVI_logo.png?1696514357',
  interlay:
    'https://assets.coingecko.com/coins/images/26180/large/Interlay-Coinbase-2.png?1696525267',
  dagger:
    'https://assets.coingecko.com/coins/images/5823/large/4nVh5M8u_400x400.jpg?1696506261',
  'outer-ring':
    'https://assets.coingecko.com/coins/images/24059/large/GQ.png?1706545366',
  'sin-city':
    'https://assets.coingecko.com/coins/images/19291/large/Sin_Verse_Logo_White_Text_White_Windows.png?1696518734',
  leisuremeta:
    'https://assets.coingecko.com/coins/images/25761/large/SVG_16533804486374586M.jpg?1696524846',
  'comtech-gold':
    'https://assets.coingecko.com/coins/images/25682/large/CGO_200x200.png?1696524810',
  'flooring-protocol-micropudgypenguins':
    'https://assets.coingecko.com/coins/images/32691/large/pudgy_penguins_64_64.png?1698974130',
  boringdao:
    'https://assets.coingecko.com/coins/images/16429/large/Tjq3pXEH_400x400.jpg?1696516025',
  'spool-dao-token':
    'https://assets.coingecko.com/coins/images/21532/large/spool.png?1696520891',
  zkspace:
    'https://assets.coingecko.com/coins/images/13585/large/image_2024-01-16_172847810.png?1705397359',
  'wickedbet-casino':
    'https://assets.coingecko.com/coins/images/31721/large/WB_B_W.png?1696530542',
  obortech:
    'https://assets.coingecko.com/coins/images/14929/large/OBORTECH_200.png?1696514590',
  galeon:
    'https://assets.coingecko.com/coins/images/24261/large/Logo-Galeon-Coinmarketcap.png?1696523445',
  tamadoge:
    'https://assets.coingecko.com/coins/images/27501/large/CaltNDWu_400x400.jpeg?1696526541',
  'metaverse-network-pioneer':
    'https://assets.coingecko.com/coins/images/26705/large/14294.png?1696525777',
  titanium22:
    'https://assets.coingecko.com/coins/images/31197/large/200PX.png?1704048243',
  'stake-link':
    'https://assets.coingecko.com/coins/images/28406/large/stake.png?1696527404',
  plex: 'https://assets.coingecko.com/coins/images/13383/large/plex.png?1696513146',
  'darwinia-network-native-token':
    'https://assets.coingecko.com/coins/images/9443/large/RING.png?1696509535',
  'gensokishis-metaverse':
    'https://assets.coingecko.com/coins/images/23143/large/geno.png?1696522435',
  'xend-finance':
    'https://assets.coingecko.com/coins/images/14496/large/WeChat_Image_20210325163206.png?1696514181',
  splyt:
    'https://assets.coingecko.com/coins/images/14600/large/shopx_icon_.png?1696514279',
  'umbrella-network':
    'https://assets.coingecko.com/coins/images/13913/large/Apple_Watch_45mm_-_3.png?1705486680',
  'trabzonspor-fan-token':
    'https://assets.coingecko.com/coins/images/13059/large/TRABZ-Token-10.png?1696512844',
  vinuchain:
    'https://assets.coingecko.com/coins/images/32324/large/vinuschain.jpg?1697413654',
  'calamari-network':
    'https://assets.coingecko.com/coins/images/20976/large/kma.png?1696520363',
  empyreal:
    'https://assets.coingecko.com/coins/images/31374/large/emplogotransparent_%281%29.png?1696530191',
  'blocto-token':
    'https://assets.coingecko.com/coins/images/18657/large/BLT_token.png?1696518127',
  spx6900:
    'https://assets.coingecko.com/coins/images/31401/large/sticker_%281%29.jpg?1702371083',
  xbit: 'https://assets.coingecko.com/coins/images/18155/large/Artboard-1-1-150x150.png?1696517657',
  magiccraft:
    'https://assets.coingecko.com/coins/images/21318/large/mcrt.png?1696520686',
  airight:
    'https://assets.coingecko.com/coins/images/16428/large/alright.PNG?1696516024',
  web3war:
    'https://assets.coingecko.com/coins/images/33643/large/FPSToken.png?1707449539',
  piteas:
    'https://assets.coingecko.com/coins/images/31582/large/piteas-256.png?1696530399',
  'eclipse-fi':
    'https://assets.coingecko.com/coins/images/31815/large/ECLIP_token_logo.png?1696530629',
  'quick-intel':
    'https://assets.coingecko.com/coins/images/29605/large/IMG_6589D0616DF1-1.jpeg?1696528542',
  plebbit:
    'https://assets.coingecko.com/coins/images/31903/large/WgMdNjT4_400x400.png?1696530713',
  rev3al:
    'https://assets.coingecko.com/coins/images/26121/large/REV3AL.png?1707513988',
  'dose-token':
    'https://assets.coingecko.com/coins/images/18847/large/dose.PNG?1696518308',
  'gui-inu':
    'https://assets.coingecko.com/coins/images/33924/large/gui_inu_tg_tiny.png?1703408231',
  prism:
    'https://assets.coingecko.com/coins/images/21475/large/7KzeGb1.png?1696520836',
  exeedme:
    'https://assets.coingecko.com/coins/images/13518/large/exeedme.png?1696513279',
  'lua-token':
    'https://assets.coingecko.com/coins/images/12627/large/Screenshot_2020-09-28_at_6.24.59_PM.jpg?1696512435',
  'athenadao-token':
    'https://assets.coingecko.com/coins/images/33349/large/ATH_Token_Black_Logo.png?1701981879',
  'neon-exchange':
    'https://assets.coingecko.com/coins/images/3246/large/Nash_M.png?1696503962',
  'lovely-inu-finance':
    'https://assets.coingecko.com/coins/images/19053/large/lovely-inu-logo-new.png?1696518503',
  oraidex:
    'https://assets.coingecko.com/coins/images/28104/large/oraix.png?1696527113',
  eden: 'https://assets.coingecko.com/coins/images/17470/large/Iyc0XM5-_400x400.jpg?1696517012',
  'big-data-protocol':
    'https://assets.coingecko.com/coins/images/14222/large/logo_BDP_200.png?1696513937',
  'pundi-x-purse':
    'https://assets.coingecko.com/coins/images/20419/large/HobiV7k__400x400.jpg?1696519827',
  'script-network':
    'https://assets.coingecko.com/coins/images/20869/large/8Z2SZTB.png?1700075234',
  'siaprime-coin':
    'https://assets.coingecko.com/coins/images/7508/large/SPRho_512x512.png?1696507776',
  skeb: 'https://assets.coingecko.com/coins/images/27155/large/skebcoin-cmc.png?1696526206',
  usk: 'https://assets.coingecko.com/coins/images/27274/large/usk.png?1696526326',
  whale:
    'https://assets.coingecko.com/coins/images/11797/large/WHALE.png?1696511673',
  gamestarter:
    'https://assets.coingecko.com/coins/images/17604/large/gpMi14-r_400x400.jpg?1696517136',
  'amulet-protocol':
    'https://assets.coingecko.com/coins/images/34716/large/AMT200x200.png?1705904544',
  'octus-bridge':
    'https://assets.coingecko.com/coins/images/25844/large/logo.png?1696524928',
  foom: 'https://assets.coingecko.com/coins/images/31308/large/f.png?1696530127',
  '5ire':
    'https://assets.coingecko.com/coins/images/25246/large/16919.png?1696524387',
  'b-cube-ai':
    'https://assets.coingecko.com/coins/images/15948/large/bcube.PNG?1696515560',
  'loki-network':
    'https://assets.coingecko.com/coins/images/3462/large/ct0LitT.png?1696504152',
  'flamengo-fan-token':
    'https://assets.coingecko.com/coins/images/19461/large/0hKQH2Cd1W3QliKBSfTdtE9yzAAuSRWhO3Ny985c.png?1696518898',
  mozaic:
    'https://assets.coingecko.com/coins/images/30100/large/Main_Logo_1-200x200jpg.jpg?1696529024',
  polkadex:
    'https://assets.coingecko.com/coins/images/14833/large/dIze5Ztl_400x400.jpg?1696514500',
  'oggy-inu':
    'https://assets.coingecko.com/coins/images/29691/large/Oggy_logo_200x200.png?1696528624',
  bountymarketcap:
    'https://assets.coingecko.com/coins/images/13472/large/bmc-logo-200.png?1696513233',
  'degen-zoo':
    'https://assets.coingecko.com/coins/images/29224/large/FAGWW5fe_400x400.jpeg?1696528182',
  'bware-infra':
    'https://assets.coingecko.com/coins/images/30546/large/infra-token-square.png?1696529418',
  'reflexer-ungovernance-token':
    'https://assets.coingecko.com/coins/images/14123/large/EAfYdwgd_400x400.jpg?1696513843',
  'portugal-national-team-fan-token':
    'https://assets.coingecko.com/coins/images/18487/large/Wr62i6lcJL91gOimUD6GT2urLC9rM50t11a1qeYU.png?1696517971',
  valleydao:
    'https://assets.coingecko.com/coins/images/32991/large/valleydao_200x200.png?1700168068',
  thorwallet:
    'https://assets.coingecko.com/coins/images/21843/large/tgt_logo.png?1696521198',
  'thol-token':
    'https://assets.coingecko.com/coins/images/25058/large/Tholos_circle_gradient_200x200.png?1696524208',
  dacxi:
    'https://assets.coingecko.com/coins/images/4466/large/dacxi.png?1696505057',
  mahadao:
    'https://assets.coingecko.com/coins/images/13404/large/MAHA_Token.png?1696513166',
  afreum:
    'https://assets.coingecko.com/coins/images/18255/large/afreum.PNG?1696517750',
  yup: 'https://assets.coingecko.com/coins/images/12322/large/photo_2021-10-26_00-47-35.jpg?1696512151',
  'digits-dao':
    'https://assets.coingecko.com/coins/images/23551/large/Logo-Digits-DAO-Icon-01.jpg?1696522758',
  kamaleont:
    'https://assets.coingecko.com/coins/images/26386/large/Dise%C3%B1o_sin_t%C3%ADtulo_%288%29.png?1696525463',
  'unitus-2':
    'https://assets.coingecko.com/coins/images/33178/large/IMG_0051.jpeg?1700924333',
  dehub:
    'https://assets.coingecko.com/coins/images/18094/large/dehub.PNG?1696517599',
  regen:
    'https://assets.coingecko.com/coins/images/16733/large/REGEN.png?1696516306',
  'santiment-network-token':
    'https://assets.coingecko.com/coins/images/797/large/santiment-network-token.png?1696501947',
  'ambire-wallet':
    'https://assets.coingecko.com/coins/images/23154/large/wallet.PNG?1696522445',
  'spectre-ai':
    'https://assets.coingecko.com/coins/images/33066/large/spectre_logo_transp_200x200.png?1700498926',
  mancium:
    'https://assets.coingecko.com/coins/images/25084/large/IKpuMYuGaMHEE0nrDUwpf6DqLQ5zTfZ1sak6ZqeIe2snV4GqQbh4Eic6hHcPl_OpBmlhcrRJ5kqoGzwB1CezMiDYnwR6rDT08_l8zb3-y3aPhTv7_0x5g4IO9JpQXDViEIqTZ7gYzTXqkcP6MH_uCFxQF-l-ohR0-FdT8O-ZTmNUKm--OuqEf9DVa-miAFp4t2pN-kcJ5Jv8woPj51yk-zna8c.jpg?1696524235',
  'btc-2x-flexible-leverage-index':
    'https://assets.coingecko.com/coins/images/15406/large/Copy_of_BTC2x-FLI_token_logo.png?1696515052',
  comdex:
    'https://assets.coingecko.com/coins/images/21540/large/CMDX_Token.png?1696520899',
  'gami-world':
    'https://assets.coingecko.com/coins/images/19841/large/DIKEY_NORMAL.png?1707406368',
  'dark-frontiers':
    'https://assets.coingecko.com/coins/images/18856/large/Twitter_post_-_121.png?1700880077',
  'wombat-exchange':
    'https://assets.coingecko.com/coins/images/26946/large/Wombat_Token.png?1696526001',
  dotmoovs:
    'https://assets.coingecko.com/coins/images/15817/large/dotmoovs-symbol-gradient.png?1696515436',
  'label-foundation':
    'https://assets.coingecko.com/coins/images/19202/large/tele_profile_%EB%8C%80%EC%A7%80_1_-_%282%29.png?1696518649',
  'roco-finance':
    'https://assets.coingecko.com/coins/images/19234/large/86109466.png?1696518680',
  byteball:
    'https://assets.coingecko.com/coins/images/561/large/byteball.png?1696501768',
  insc: 'https://assets.coingecko.com/coins/images/30287/large/insc.jpg?1696529192',
  multivac:
    'https://assets.coingecko.com/coins/images/4937/large/MultiVAC.png?1696505477',
  'fxn-token':
    'https://assets.coingecko.com/coins/images/31889/large/FXN_200x200.png?1696530700',
  'don-t-buy-inu':
    'https://assets.coingecko.com/coins/images/28058/large/1Artboard_1_%282%29.png?1696527070',
  cypherium:
    'https://assets.coingecko.com/coins/images/7332/large/cph.PNG?1696507618',
  mars4:
    'https://assets.coingecko.com/coins/images/18709/large/mars4_logo.jpg?1696518177',
  grai: 'https://assets.coingecko.com/coins/images/30427/large/GRAI_Token.png?1696529315',
  'stobox-token':
    'https://assets.coingecko.com/coins/images/12637/large/123456826.png?1696512445',
  dinolfg:
    'https://assets.coingecko.com/coins/images/28239/large/F1giO3rXsAAFOsG.jpg?1696527242',
  suipad:
    'https://assets.coingecko.com/coins/images/30284/large/25100.png?1696529189',
  defit:
    'https://assets.coingecko.com/coins/images/14699/large/Defit.png?1696514370',
  'feisty-doge-nft':
    'https://assets.coingecko.com/coins/images/17834/large/doge-fractionalized.png?1696517355',
  'bitcoin-2':
    'https://assets.coingecko.com/coins/images/5925/large/bitcoin2_logo256.png?1696506352',
  'bbs-network':
    'https://assets.coingecko.com/coins/images/23715/large/Ni13Pg1K_400x400.jpg?1696522915',
  giddy:
    'https://assets.coingecko.com/coins/images/24960/large/gddy.png?1696524114',
  geeq: 'https://assets.coingecko.com/coins/images/11953/large/GeeqLogoPNGTransparent-1.png?1696511812',
  bytecoin:
    'https://assets.coingecko.com/coins/images/92/large/bytecoin-logo.png?1696501475',
  pikaboss:
    'https://assets.coingecko.com/coins/images/32061/large/logocg.png?1696530858',
  'xpense-2':
    'https://assets.coingecko.com/coins/images/32359/large/xpenselogonew.png?1700451287',
  astroport:
    'https://assets.coingecko.com/coins/images/20804/large/Astro_coin_icon.png?1696520197',
  timeless:
    'https://assets.coingecko.com/coins/images/28714/large/timeless-logo_3x.png?1696527695',
  'derby-stars-run':
    'https://assets.coingecko.com/coins/images/31203/large/download.png?1696530030',
  'conic-finance':
    'https://assets.coingecko.com/coins/images/24747/large/cnc.png?1696523909',
  'ufc-fan-token':
    'https://assets.coingecko.com/coins/images/18534/large/nDcBVdzyEUpcUOjCKzgTH5VihLJpWRhqhyinhX6Z.png?1696518014',
  'beethoven-x':
    'https://assets.coingecko.com/coins/images/19158/large/beets-icon-large.png?1696518608',
  breederdao:
    'https://assets.coingecko.com/coins/images/25203/large/BreederDAO-Breed_Token-FINAL.png?1696524347',
  'bridge-oracle':
    'https://assets.coingecko.com/coins/images/12512/large/brg.png?1696512327',
  netswap:
    'https://assets.coingecko.com/coins/images/22262/large/netswpa.PNG?1696521606',
  'era-swap-token':
    'https://assets.coingecko.com/coins/images/6031/large/era_swap.PNG?1696506442',
  apwine:
    'https://assets.coingecko.com/coins/images/15597/large/spectra.png?1696515232',
  vixco:
    'https://assets.coingecko.com/coins/images/15405/large/vixco.png?1696515051',
  tokensight:
    'https://assets.coingecko.com/coins/images/32514/large/token-coingecko.png?1698401758',
  wecan:
    'https://assets.coingecko.com/coins/images/32150/large/Wecan_W_logo_RGB.png?1702947005',
  xels: 'https://assets.coingecko.com/coins/images/14729/large/Xels_logo_square_%281%29.png?1696514398',
  subsocial:
    'https://assets.coingecko.com/coins/images/15880/large/icon___gradient_1.png?1696515495',
  'fore-protocol':
    'https://assets.coingecko.com/coins/images/31001/large/EXCHANGE_LOGO_FORE.png?1696529839',
  'rocky-the-dog':
    'https://assets.coingecko.com/coins/images/33482/large/ROCKY.png?1702020138',
  'kunci-coin':
    'https://assets.coingecko.com/coins/images/23723/large/xZX34B26_400x400.jpg?1696522923',
  xfund:
    'https://assets.coingecko.com/coins/images/13770/large/xfund.png?1696513512',
  'molecules-of-korolchuk-ip-nft':
    'https://assets.coingecko.com/coins/images/33055/large/Vita-FAST_1024px.png?1700475313',
  'uxd-stablecoin':
    'https://assets.coingecko.com/coins/images/22850/large/UXD-White.png?1696522151',
  'rari-governance-token':
    'https://assets.coingecko.com/coins/images/12900/large/Rari_Logo_Transparent.png?1696512688',
  'electra-protocol':
    'https://assets.coingecko.com/coins/images/13589/large/Apple-iPhone-Icon-Retina.png?1696513341',
  superwalk:
    'https://assets.coingecko.com/coins/images/27186/large/GRND_3x.png?1696526235',
  'unstake-fi':
    'https://assets.coingecko.com/coins/images/33110/large/nstk.png?1700705727',
  'anchor-protocol':
    'https://assets.coingecko.com/coins/images/14420/large/anchor_protocol_logo.jpg?1696514111',
  'rae-token':
    'https://assets.coingecko.com/coins/images/9428/large/Copy_of_raetoken.png?1696509521',
  'kineko-knk':
    'https://assets.coingecko.com/coins/images/26597/large/knk-cmc-logo.png?1696525672',
  aimbot:
    'https://assets.coingecko.com/coins/images/31200/large/200x200.jpg?1696530027',
  'oxbull-tech-2':
    'https://assets.coingecko.com/coins/images/27781/large/CG_logo_%282%29.png?1696526802',
  revain:
    'https://assets.coingecko.com/coins/images/1107/large/256x256.png?1696502203',
  bondly:
    'https://assets.coingecko.com/coins/images/13322/large/FORJ_twitter_twitter-linked_in_profile_%281%29.png?1696513091',
  'luxurious-pro-network-token':
    'https://assets.coingecko.com/coins/images/14126/large/logo_%2894%29.png?1696513847',
  quint:
    'https://assets.coingecko.com/coins/images/25194/large/logo-200x200.png?1696524338',
  republik:
    'https://assets.coingecko.com/coins/images/32950/large/RPK_Token_Logo_2x.png?1699935349',
  earnbet:
    'https://assets.coingecko.com/coins/images/32032/large/logo.png?1696530829',
  'dvision-network':
    'https://assets.coingecko.com/coins/images/13020/large/WGAhHOLv_400x400.png?1696512809',
  luca: 'https://assets.coingecko.com/coins/images/21278/large/luca.PNG?1696520648',
  diamond:
    'https://assets.coingecko.com/coins/images/165/large/DMD_LOGO_BLUE.png?1696501536',
  assetmantle:
    'https://assets.coingecko.com/coins/images/25181/large/thumbnail.png?1696524326',
  kan: 'https://assets.coingecko.com/coins/images/4651/large/kan-token.png?1696505219',
};
